(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@skype/tsregistrar"));
	else if(typeof define === 'function' && define.amd)
		define("@skype/tstrouter", ["@skype/tsregistrar"], factory);
	else if(typeof exports === 'object')
		exports["@skype/tstrouter"] = factory(require("@skype/tsregistrar"));
	else
		root["@skype/tstrouter"] = factory(root["@skype/tsregistrar"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_20__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 19);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Simple logger
 */
var Logger = /** @class */ (function () {
    function Logger(name, logger) {
        this.name = name;
        this.logger = logger;
    }
    Logger.prototype.debug = function (message) {
        this.logger.debug("[" + this.name + "] " + message);
    };
    Logger.prototype.info = function (message) {
        this.logger.info("[" + this.name + "] " + message);
    };
    Logger.prototype.warn = function (message) {
        this.logger.warn("[" + this.name + "] " + message);
    };
    Logger.prototype.error = function (message) {
        this.logger.error("[" + this.name + "] " + message);
    };
    return Logger;
}());
exports.Logger = Logger;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.constants = {
    TROUTER_INIT: 'trouterinit',
    TROUTER_READY_EVENT: 'trouterReadyEvent',
    TROUTER_READY_TIMEOUT: 'trouterReadyTimeout',
    TROUTER_TOKEN_REQUEST: 'trouterTokenRequest',
    TROUTER_TOKEN_GET_SUCCEEDED: 'trouterTokenGetSucceeded',
    TROUTER_TOKEN_GET_FAILED: 'trouterTokenGetFailed',
    TROUTER_RECONNECTING: 'trouterReconnecting',
    RENEWAL: 'renewal',
    NEW_CONNECTION: 'newConnection',
    ENDPOINT_REGISTRATION_FAILED: 'endpointRegistrationFailed'
};
exports.CLIENT_VERSION = '2022.35.01.26';
exports.HANDLED_MESSAGE_ACK = 200;
exports.UNHANDLED_MESSAGE_ACK = 404;
exports.FAILED_MESSAGE_ACK = 500;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 * Type definitions for Trouter JavaScript Client 2022.35.01.26
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * States that a user can reach
 *
 * Use with the `setUserActivityState()` method.
 */
var UserActivityState;
(function (UserActivityState) {
    UserActivityState[UserActivityState["Unknown"] = 0] = "Unknown";
    UserActivityState[UserActivityState["Active"] = 1] = "Active";
    UserActivityState[UserActivityState["Inactive"] = 2] = "Inactive"; /// User is not active according to the application
})(UserActivityState = exports.UserActivityState || (exports.UserActivityState = {}));
/** Headers for HTTP request */
var HttpHeaders = /** @class */ (function () {
    function HttpHeaders() {
    }
    return HttpHeaders;
}());
exports.HttpHeaders = HttpHeaders;
var TrouterState;
(function (TrouterState) {
    /** Initial state */
    TrouterState[TrouterState["Unknown"] = 0] = "Unknown";
    /** ready to work */
    TrouterState[TrouterState["Connected"] = 2] = "Connected";
    /** waiting for 'connected' event */
    TrouterState[TrouterState["Disconnected"] = 3] = "Disconnected";
    /** waiting for 'register' from second connection */
    TrouterState[TrouterState["Switching"] = 9] = "Switching";
})(TrouterState = exports.TrouterState || (exports.TrouterState = {}));


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:no-any
// tslint:disable:export-name
// tslint:disable:function-name
function toJson(obj) {
    try {
        return JSON.stringify(obj);
    }
    catch (error) {
        return "Unable to serialize object of type " + typeof obj;
    }
}
exports.toJson = toJson;
function calculateTtlInSec(expirationTsInSec) {
    var now = Math.round(new Date().getTime() / 1000);
    return expirationTsInSec !== undefined && expirationTsInSec > now
        ? expirationTsInSec - now
        : 0;
}
exports.calculateTtlInSec = calculateTtlInSec;
function calculateExpireTsInSec(ttlInSec) {
    return Math.round(new Date().getTime() / 1000) + ttlInSec;
}
exports.calculateExpireTsInSec = calculateExpireTsInSec;
/** Wrapper to send request with specified timeout */
function fetchWithTimeout(request, timeoutMs) {
    return __awaiter(this, void 0, void 0, function () {
        var timeoutId, fetchPromise, timeoutPromise;
        return __generator(this, function (_a) {
            fetchPromise = new Promise(function (resolve, reject) {
                fetch(request).then(function (response) {
                    clearTimeout(timeoutId);
                    resolve(response);
                }).catch(function (error) {
                    clearTimeout(timeoutId);
                    reject(error);
                });
            });
            if (timeoutMs !== 0) {
                timeoutPromise = new Promise(function (resolve, reject) {
                    // We make a compromise on how much information to show in the error message.
                    // Having the URL there is useful, but including any query parameters is both
                    // cumbersome (millions of different errors in telemetry) and unsafe (secret
                    // fields that would need to be redacted). "Origin" and "pathname" achieve that.
                    var url = new URL(request.url);
                    var error = new Error(request.method + " " + url.origin + url.pathname + " timed out");
                    // tslint:disable-next-line:no-string-based-set-timeout - false positive on 'reject'
                    timeoutId = setTimeout(reject, timeoutMs, error);
                });
                return [2 /*return*/, Promise.race([fetchPromise, timeoutPromise])];
            }
            return [2 /*return*/, fetchPromise];
        });
    });
}
exports.fetchWithTimeout = fetchWithTimeout;
/***
 * Correlation vector
 */
var CorrelationVector = /** @class */ (function () {
    function CorrelationVector(correlationVector) {
        this.base = (correlationVector !== undefined) ? correlationVector : this.createCorrelationVectorBase();
        this.extension = 0;
    }
    CorrelationVector.extend = function (correlationVector) {
        return new CorrelationVector(correlationVector);
    };
    CorrelationVector.prototype.increase = function () {
        this.extension++;
    };
    CorrelationVector.prototype.value = function () {
        return this.base + "." + this.extension;
    };
    CorrelationVector.prototype.createCorrelationVectorBase = function () {
        var length = 21;
        var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0987654321/+';
        var endChars = 'AQgw';
        var result = '';
        for (var i = 0; i < length; i++) {
            // tslint:disable-next-line:insecure-random
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        // tslint:disable-next-line:insecure-random
        result += endChars.charAt(Math.floor(Math.random() * endChars.length));
        return result;
    };
    return CorrelationVector;
}());
exports.CorrelationVector = CorrelationVector;
/**
 * Simplify calculation of time intervals
 */
var Timespan = /** @class */ (function () {
    function Timespan() {
        this.start = Date.now();
    }
    Object.defineProperty(Timespan.prototype, "duration", {
        /**
         * Returns number of milliseconds from start
         */
        get: function () {
            return Date.now() - this.start;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Timespan.prototype, "startTime", {
        /**
         * Returns start time
         */
        get: function () {
            return this.start;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Reset start of interval to current timestamp
     */
    Timespan.prototype.reset = function () {
        this.start = Date.now();
    };
    return Timespan;
}());
exports.Timespan = Timespan;


/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 * Internal type definitions for Trouter JavaScript Client
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Common_1 = __webpack_require__(3);
/**
 * Information about server connection
 */
var ServerState = /** @class */ (function () {
    function ServerState(
    /** Trouter client connection ID */
    connectionId, 
    /** Trouter client connected client ID */
    connectedClientId, 
    /** window.location.hostname */
    domId, 
    /** Unsecure Trouter url at which client can be reached */
    unsecureUrl, 
    /** Secure Trouter url at which client can be reached */
    url, 
    /** URL base to use for client-to-client requests */
    c2cUrlBase, 
    /** expiration timestamp for connection in seconds */
    expirationTsSec) {
        this.connectionId = connectionId;
        this.connectedClientId = connectedClientId;
        this.domId = domId;
        this.unsecureUrl = unsecureUrl;
        this.url = url;
        this.c2cUrlBase = c2cUrlBase;
        this.expirationTsSec = expirationTsSec;
    }
    /** Return connection TTL, i.e. number of seconds till expiration */
    ServerState.prototype.getRemainingTtlInSec = function () {
        return Common_1.calculateTtlInSec(this.expirationTsSec);
    };
    return ServerState;
}());
exports.ServerState = ServerState;
var UserActivityEventReason;
(function (UserActivityEventReason) {
    UserActivityEventReason[UserActivityEventReason["Unknown"] = 0] = "Unknown";
    UserActivityEventReason[UserActivityEventReason["Modified"] = 1] = "Modified";
    UserActivityEventReason[UserActivityEventReason["Snapshot"] = 2] = "Snapshot";
    UserActivityEventReason[UserActivityEventReason["Connected"] = 3] = "Connected";
})(UserActivityEventReason = exports.UserActivityEventReason || (exports.UserActivityEventReason = {}));


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 */
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:no-any
// tslint:disable:no-unsafe-any
// tslint:disable:strict-boolean-expressions
// tslint:disable:max-classes-per-file
// tslint:disable:promise-function-async
var tsregistrar_1 = __webpack_require__(20);
var es6_promise_1 = __webpack_require__(12);
var Common_1 = __webpack_require__(3);
var ConnectionTracker_1 = __webpack_require__(15);
var Constants_1 = __webpack_require__(1);
var ExponentialBackoff_1 = __webpack_require__(16);
var Interfaces_1 = __webpack_require__(2);
var InternalInterfaces_1 = __webpack_require__(5);
var Logger_1 = __webpack_require__(0);
var TrouterFsm_1 = __webpack_require__(17);
// This is the current API version
var VERSION = 'v4';
// Default value for registration timeout
var DEFAULT_REGISTRATION_TIMEOUT_SEC = 3600;
var io = __webpack_require__(11);
/**
 * Stub for IClientInfo
 */
var ClientInfo = /** @class */ (function () {
    function ClientInfo() {
        this.cv = Constants_1.CLIENT_VERSION;
        this.ua = '';
        this.hr = '';
        this.v = '';
    }
    return ClientInfo;
}());
/**
 * Stub for ISocketIoOptions
 */
var SocketIoOptions = /** @class */ (function () {
    function SocketIoOptions() {
        this['force new connection'] = true;
        this['reconnect'] = false;
        this['query'] = '';
        this.ackTimeoutMs = 5000;
    }
    return SocketIoOptions;
}());
var cvHeader = 'MS-CV';
/**
 * Request from downstream service
 */
var TrouterRequest = /** @class */ (function () {
    function TrouterRequest(requestJson) {
        this.cvCounter = 0;
        var json = JSON.parse(requestJson);
        this.startTS = json.hasOwnProperty('startTS') ? json.startTS : 0;
        this.url = json.hasOwnProperty('url') ? json.url : '';
        this.shortUrl = json.hasOwnProperty('shortUrl') ? json.shortUrl : '';
        this.body = json.hasOwnProperty('body') ? json.body : '';
        this.headers = json.hasOwnProperty('headers') ? json.headers : {};
        this.id = (json.hasOwnProperty('id') && typeof json.id === 'number') ? json.id : -1;
        this.method = json.hasOwnProperty('method') ? json.method : '';
        this.replied = false;
        this.timedout = false;
        this.timeoutTimerId = 0;
        this.receivedCv = this.headers[cvHeader];
        this.updateCvHeader();
    }
    Object.defineProperty(TrouterRequest.prototype, "correlationVector", {
        get: function () {
            return this.receivedCv ? this.receivedCv + "." + this.cvCounter : '';
        },
        enumerable: true,
        configurable: true
    });
    TrouterRequest.prototype.on = function (target, targetCallback) {
        if (target === 'data') {
            this.dataCallback = targetCallback;
        }
        else if (target === 'end') {
            if (typeof this.dataCallback === 'function') {
                this.dataCallback(this.body);
            }
            targetCallback();
        }
    };
    TrouterRequest.prototype.incrementCorrelationVector = function () {
        ++this.cvCounter;
        this.updateCvHeader();
    };
    TrouterRequest.prototype.updateCvHeader = function () {
        var cv = this.correlationVector;
        if (cv) {
            this.headers[cvHeader] = cv;
        }
    };
    return TrouterRequest;
}());
/**
 * Response to downstream service
 */
var TrouterResponse = /** @class */ (function () {
    function TrouterResponse(request, responseData, sendResponse) {
        this.request = request;
        this.responseData = responseData;
        this.sendResponse = sendResponse;
    }
    TrouterResponse.prototype.writeHead = function (status, headers) {
        this.responseData.status = status;
        this.responseData.headers = headers;
    };
    TrouterResponse.prototype.write = function (chunk) {
        this.responseData.body += chunk;
    };
    TrouterResponse.prototype.end = function (chunk) {
        if (chunk) {
            this.responseData.body += chunk;
        }
        return this.sendResponse(this.request, this.responseData);
    };
    return TrouterResponse;
}());
/**
 * An client-initiated event that is to be sent to trouter.
 */
var DownstreamEvent = /** @class */ (function () {
    function DownstreamEvent(name) {
        this.name = name;
        this.args = {};
        this.timeoutTimerId = 0;
    }
    return DownstreamEvent;
}());
/**
 * Reason why a connection switch is happening.
 */
var ReconnectReason;
(function (ReconnectReason) {
    /** Configuration change coming from ECS, containing different URL */
    ReconnectReason[ReconnectReason["Configuration"] = 0] = "Configuration";
    /** In response to a `trouter.reconnect` socket.io event */
    ReconnectReason[ReconnectReason["ServerInitiated"] = 1] = "ServerInitiated";
})(ReconnectReason = exports.ReconnectReason || (exports.ReconnectReason = {}));
/**
 * Trouter + registration flow implementation
 */
var TrouterConnection = /** @class */ (function () {
    function TrouterConnection(logProvider, options, manager, tokenProvider, initialUserActivityState) {
        var _this = this;
        this.options = options;
        this.manager = manager;
        this.tokenProvider = tokenProvider;
        this.connectionId = '';
        this.inIncallMode = false;
        this.connectionAttempt = 0;
        this.connectedClientId = '';
        this.isNavigatorOnline = true;
        this.onNavigatorOnlineStatusUpdateBound = this.onNavigatorOnlineStatusUpdate.bind(this); // Bound to allow removing the listener
        this.c2cUrlBase = '';
        this.allocationErrorsInRow = 0;
        /** Keeps track of 401s */
        this.unauthorizedErrorCount = 0;
        this.pendingTimers = {};
        this.lastDisconnectReason = '';
        this.UNKNOWN_TRANSPORT = 'unknown_transport';
        this.logger = new Logger_1.Logger('Connection', logProvider);
        this.timeoutOptions = this.options.timeoutOptions;
        this.tokenBackoff = new ExponentialBackoff_1.ExponentialBackoff(this.logger, this.timeoutOptions.maxBackoffMs);
        this.clientID = Date.now();
        // tslint:disable-next-line:no-typeof-undefined - window exists only in browser
        if ((typeof window !== 'undefined') && window.location) {
            this.domId = window.location.hostname;
        }
        this.clientInfo = new ClientInfo();
        this.clientInfo.cv = Constants_1.CLIENT_VERSION;
        this.clientInfo.ua = '';
        if (this.options && this.options.clientInfo) {
            this.clientInfo.ua = this.safeString(this.options.clientInfo.ua);
            this.clientInfo.v = this.safeString(this.options.clientInfo.v);
        }
        this.connectionTracker = new ConnectionTracker_1.ConnectionTracker(logProvider, this.clientID, this.clientInfo, function () { return _this.getServerState(); }, this.options.endpointId, this.options.clientCorrelationID, this.options.environment);
        this.applyConnectionTrackerOptions(options);
        var useIncallMode = this.options.incallModeTimeoutMs > 0;
        this.fsm = new TrouterFsm_1.TrouterFsm(logProvider, this, useIncallMode);
        if (options.registration) {
            var registrarOptions = {
                registrarUrl: options.registration.registrarUrl,
                registrationId: options.registration.registrationId,
                requestTimeoutMs: options.timeoutOptions.fetchTimeoutMs,
                initialRetryDelayMs: 1000,
                maxRetryDelayMs: options.timeoutOptions.maxBackoffMs
            };
            this.registrarClient = tsregistrar_1.createRegistrarClient(logProvider, this.tokenProvider, registrarOptions);
        }
        this.userActivityState = initialUserActivityState;
    }
    TrouterConnection.prototype.start = function (externalConnectParams) {
        this.logger.info('Starting');
        this.reconnectParams = externalConnectParams;
        // tslint:disable-next-line:no-typeof-undefined - window exists only in browser
        if (typeof window !== 'undefined' && window.navigator) {
            this.isNavigatorOnline = window.navigator.onLine;
            window.addEventListener('online', this.onNavigatorOnlineStatusUpdateBound);
            window.addEventListener('offline', this.onNavigatorOnlineStatusUpdateBound);
            this.logger.debug("Registered for browser online notifications - current state: " + this.isNavigatorOnline);
        }
        else {
            this.isNavigatorOnline = true; // Assume always online if the API is not available
        }
        this.fsm.start();
    };
    TrouterConnection.prototype.stop = function (dontUnregister) {
        this.logger.info('Stopping');
        // tslint:disable-next-line:no-typeof-undefined - window exists only in browser
        if (typeof window !== 'undefined' && window.navigator) {
            window.removeEventListener('online', this.onNavigatorOnlineStatusUpdateBound);
            window.removeEventListener('offline', this.onNavigatorOnlineStatusUpdateBound);
        }
        this.fsm.stop(dontUnregister);
        this.connectionTracker.close();
    };
    TrouterConnection.prototype.configure = function (options) {
        // Currently only baseUrl and telemetrySettings options are supported for reconfiguration
        var urlChanged = this.options.trouterUrl !== options.trouterUrl;
        this.options = options;
        this.applyConnectionTrackerOptions(options);
        if (urlChanged) {
            this.logger.info('Configuration changed. Reconnection required.');
            this.fsm.onReconnectRequired(false, ReconnectReason.Configuration);
        }
    };
    TrouterConnection.prototype.checkConnection = function (disconnectDetected) {
        this.logger.info("checkConnection called with " + disconnectDetected);
        this.fsm.checkConnection(disconnectDetected);
        // Don't send on disconnectDetected === false, because Teams client calls it on timer
        if (disconnectDetected) {
            this.connectionTracker.sendTelemetry(ConnectionTracker_1.ClientEventName.CheckConnection, {
                disconnectDetected: disconnectDetected
            }, []);
        }
    };
    TrouterConnection.prototype.disableRegistrationsAndAutoReconnect = function () {
        this.stopRegisterTimer();
        this.resetRegisterBackoff();
        this.fsm.disableAutoReconnect();
    };
    /** Returns info about connection */
    TrouterConnection.prototype.getServerState = function () {
        return new InternalInterfaces_1.ServerState(this.connectionId, this.connectedClientId, this.domId ? this.domId : '', this.allocateResult ? this.allocateResult.url : '', this.allocateResult ? this.allocateResult.surl : '', this.c2cUrlBase, this.connectionExpireTimestampInSecs);
    };
    //////// Implement IWorker ////////
    TrouterConnection.prototype.getToken = function (useCache, backoff, retryCounter) {
        var _this = this;
        if (retryCounter === void 0) { retryCounter = 0; }
        this.logger.info("Getting token " + (backoff ? 'with backoff' : 'without backoff'));
        var requestFunction = function () {
            _this.connectionTracker.trackStart('token');
            // tslint:disable-next-line:no-floating-promises
            _this.tokenProvider(!useCache).then(function (token) {
                _this.logger.debug('token is received');
                _this.connectionTracker.trackEnd('token');
                _this.fsm.onTokenReceived(token);
            }).catch(function (error) {
                var msg = Common_1.toJson(error.stack);
                _this.logger.error("Getting token failed, will retry after timeout. Error: " + msg);
                _this.connectionTracker.trackError('token', msg);
                // Can't retry getToken request, which means client would not receive any notifications from trouter.
                // Unrecoverable error unless client tries to reconnect with Trouter
                //     - retryCounter tracks internal loop
                //     - unauthorizedErrorCount tracks external loop (consecutive number of sendAllocationFailures as a result of 401s)
                if (!_this.canRetryTokenFetchRequest(retryCounter + _this.unauthorizedErrorCount)) {
                    var errorMessage = 'getToken retry limit hit, reached terminal error state';
                    _this.connectionTracker.trackError('token', errorMessage);
                    _this.resetTokenBackoff();
                    _this.fsm.onTerminalError();
                    return;
                }
                _this.getToken(useCache, true, retryCounter + 1);
            });
        };
        if (backoff) {
            this.tokenBackoff.backoff('getting token', requestFunction);
        }
        else {
            this.resetTokenBackoff();
            requestFunction();
        }
    };
    TrouterConnection.prototype.startConnectionTimer = function () {
        var _this = this;
        this.stopConnectionTimer();
        this.logger.debug("Starting connection timeout for " + this.timeoutOptions.connectionTimeoutMs + " ms");
        this.connectionTimeoutId = setTimeout(function () {
            _this.logger.info('Connection timeout is fired');
            _this.fsm.onConnectingTimeout();
        }, this.timeoutOptions.connectionTimeoutMs);
    };
    TrouterConnection.prototype.stopConnectionTimer = function () {
        if (this.connectionTimeoutId) {
            this.logger.debug('Stopping connection timeout');
            clearTimeout(this.connectionTimeoutId);
            this.connectionTimeoutId = undefined;
        }
    };
    TrouterConnection.prototype.startPingTimer = function () {
        var _this = this;
        if (this.transportTypeName === 'websocket') {
            this.logger.debug("Starting ping timeout for " + this.timeoutOptions.pingTimeoutMs + " ms");
            this.pingTimerId = setInterval(function () {
                _this.logger.info('Ping interval fired');
                _this.fsm.onPingInterval();
            }, this.timeoutOptions.pingTimeoutMs);
        }
        else {
            this.logger.debug("Not starting ping for transport " + this.transportTypeName);
        }
    };
    TrouterConnection.prototype.stopPingTimer = function () {
        if (this.pingTimerId) {
            this.logger.debug('Stopping ping timeout');
            this.clearPingResponseTimer();
            clearInterval(this.pingTimerId);
            this.pingTimerId = undefined;
        }
    };
    TrouterConnection.prototype.shouldSkipRegistration = function () {
        return this.options.registration === undefined;
    };
    TrouterConnection.prototype.hasCustomRegisterTtl = function () {
        return this.options.registration && this.options.registration.registrarTtlSec;
    };
    TrouterConnection.prototype.startRegisterTimer = function () {
        var _this = this;
        if (this.registrationTimerId !== undefined) {
            this.stopRegisterTimer();
        }
        var timeForReregistrationSec = 30;
        var _a = this.getRegistrationTtl(), ttl = _a[0], _ = _a[1];
        var delay = ttl - timeForReregistrationSec;
        // Check bug(#2676421) for more info
        if (delay <= 0) {
            this.logger.debug("Not starting registration timer, ttl too low(" + ttl + " sec)");
            return;
        }
        this.logger.debug("Starting registration timeout for " + delay + " sec");
        this.registrationTimerId = setTimeout(function () {
            _this.logger.info('Registration timeout is fired');
            _this.registrationTimerId = setTimeout(function () {
                _this.registrationTimerId = undefined;
                _this.logger.debug('Re-registration did not happen in time');
                _this.dispatchUnregistered();
            }, timeForReregistrationSec * 1000);
            _this.fsm.onRegistrationTimeout();
        }, delay * 1000);
    };
    TrouterConnection.prototype.stopRegisterTimer = function () {
        if (this.registrationTimerId) {
            this.logger.debug('Stopping registration timeout');
            clearTimeout(this.registrationTimerId);
            this.registrationTimerId = undefined;
        }
    };
    TrouterConnection.prototype.resendRegistration = function () {
        if (!this.registrarClient) {
            throw new Error('Trouter Client not configured to handle registrations');
        }
        return this.registrarClient.resendRegistration();
    };
    TrouterConnection.prototype.buildSocketIoUrlParams = function () {
        if (!this.allocateResult) {
            throw new Error('Allocate result is undefined in buildSocketIoUrlParams()');
        }
        var urlParams = {};
        // Copy connection parameters (i.e. signature) from allocation response
        var signatureData = this.allocateResult.connectparams;
        for (var _i = 0, _a = Object.keys(signatureData); _i < _a.length; _i++) {
            var i = _a[_i];
            if (signatureData.hasOwnProperty(i) && signatureData[i] !== undefined) {
                urlParams[i] = signatureData[i];
            }
        }
        // And add some more fields
        urlParams.v = VERSION;
        urlParams.tc = encodeURI(Common_1.toJson(this.clientInfo));
        urlParams.timeout = this.timeoutOptions.pingTimeoutMs / 1000;
        urlParams.auth = 'true';
        if (this.options.endpointId) {
            urlParams.epid = this.options.endpointId;
        }
        if (this.userActivityState.state !== Interfaces_1.UserActivityState.Unknown) {
            urlParams.userActivity = encodeURI(Common_1.toJson(this.userActivityState.toEventObject()));
        }
        return this.appendConnectedClientIds(this.buildQuery(urlParams), true);
    };
    TrouterConnection.prototype.startSocketIo = function () {
        var _this = this;
        this.logger.info('Starting socket io');
        this.connectionTracker.trackStart('connectSocket');
        //this.connectionAttempt++;
        if (!this.allocateResult) {
            throw new Error('Allocate result is undefined in startSocketIo()');
        }
        var options = this.options.ioOptions || new SocketIoOptions();
        // Regardless of any passed in socket.io options, force the following settings.
        options['force new connection'] = true;
        options.reconnect = false;
        // Query params to each socket.io request
        options.query = this.buildSocketIoUrlParams();
        this.logger.info("connecting to " + this.allocateResult.socketio + "?" + options.query);
        // msg868 - clear all events and disconnect
        this.stopSocketIo();
        this.socket = (this.options.io || io).connect(this.allocateResult.socketio, options);
        if (this.socket === undefined) {
            throw new Error('Can\'t create Socket.io object');
        }
        this.socket.on('connecting', function (transportTypeName) { _this.onSocketConnecting(transportTypeName); });
        this.socket.on('connect', function () { _this.onSocketConnect(); });
        this.socket.on('connect_failed', function (reason) { _this.onSocketConnectFailed(reason); });
        this.socket.on('disconnect', function (reason) { _this.onSocketDisconnect(reason); });
        this.socket.on('reconnect', function () { _this.onSocketReconnect(); });
        this.socket.on('reconnect_failed', function (reason) { _this.onSocketReconnectFailed(reason); });
        this.socket.on('reconnecting', function () { _this.onSocketReconnecting(); });
        this.socket.on('error', function (error) { _this.onSocketError(error); });
        this.socket.on('message', function (request) { _this.onSocketMessage(request); });
        this.socket.on('trouter.connected', function (eventArgs) { _this.onTrouterConnected(eventArgs); });
        this.socket.on('trouter.reconnect', function (eventArgs) { _this.onTrouterReconnect(eventArgs); });
        this.socket.on('trouter.message_loss', function (eventArgs) { _this.onTrouterMessageLoss(eventArgs); });
    };
    TrouterConnection.prototype.stopSocketIo = function () {
        if (this.socket) {
            this.logger.info('clearing socket.io');
            try {
                for (var _i = 0, _a = [
                    'connecting', 'connect', 'connect_failed', 'disconnect', 'reconnect', 'reconnect_failed',
                    'reconnecting', 'error', 'message', 'trouter.connected', 'trouter.reconnect', 'trouter.message_loss'
                ]; _i < _a.length; _i++) {
                    var event_1 = _a[_i];
                    this.socket.removeAllListeners(event_1);
                }
                this.socket.disconnect();
                this.logger.debug('cleared socket');
                this.socket = undefined;
            }
            catch (error) {
                this.logger.error("exception in disconnecting previous socket. Error: " + Common_1.toJson(error.stack));
            }
        }
    };
    TrouterConnection.prototype.dispatchConnected = function () {
        this.logger.info('dispatching connected');
        this.manager.onConnected(this);
    };
    TrouterConnection.prototype.dispatchRegistered = function () {
        this.logger.info('dispatching registered');
        this.manager.onRegistered(this);
    };
    TrouterConnection.prototype.dispatchUnregistered = function () {
        this.logger.info('dispatching unregistered');
        this.manager.onUnregistered(this);
    };
    TrouterConnection.prototype.dispatchDownstreamRequest = function (request) {
        var _this = this;
        this.logger.info('dispatching downstream request');
        try {
            var response = new TrouterResponse(request, new ConnectionTracker_1.ResponseData(request.id), function (req, responseData) {
                _this.logger.info('sending response to downstream');
                return _this.sendResponse(req, responseData);
            });
            this.manager.onDownstreamRequest(this, request, response);
        }
        catch (error) {
            this.logger.error("exception in socket.on message. Error : " + Common_1.toJson(error.stack));
        }
    };
    TrouterConnection.prototype.dispatchReconnecting = function () {
        this.logger.info('dispatching reconnecting');
        this.manager.onReconnecting(this);
    };
    TrouterConnection.prototype.dispatchReconnectIsRequired = function (useConnectParamsFromCache, reason) {
        this.logger.info('dispatching reconnect is required by server');
        this.manager.onReconnectIsRequired(this, useConnectParamsFromCache, reason);
    };
    TrouterConnection.prototype.dispatchDisconnected = function () {
        this.logger.info('dispatching disconnected');
        this.manager.onDisconnected(this);
    };
    TrouterConnection.prototype.dispatchTrouterMessageLost = function (messageLossIndicators) {
        this.logger.info('dispatching trouter lost message');
        this.manager.onTrouterMessageLost(messageLossIndicators);
    };
    TrouterConnection.prototype.sendProcessedDroppedIndicators = function (messageLossIndicators) {
        var _this = this;
        try {
            this.logger.info('emitting processed flow tags to the server');
            var processedMessageLossEvent = new DownstreamEvent('trouter.processed_message_loss');
            processedMessageLossEvent.args = { droppedIndicators: messageLossIndicators };
            this.sendDownstreamEvent(processedMessageLossEvent, function () {
                _this.logger.info('emitted processed flow tags to the server');
            });
        }
        catch (error) {
            var msg = Common_1.toJson(error.stack);
            this.logger.error("unable to send processed message loss event. Error: " + msg);
            this.connectionTracker.trackError('trouter.processed_message_loss', msg, false);
        }
    };
    // tslint:disable-next-line:max-func-body-length
    TrouterConnection.prototype.sendAllocateRequest = function (token) {
        var _this = this;
        this.connectionAttempt++;
        this.connectionTracker.trackNewConnection();
        var serviceUrl = this.options.trouterUrl;
        var url = serviceUrl;
        var connectParams;
        var rp = this.reconnectParams;
        if (rp && rp.se && parseInt(rp.se, 10) <= Date.now() + 3600000) { // 1 hour
            this.logger.warn("Dropping expired cached connection parameters: " + new Date(parseInt(rp.se, 10)));
            this.reconnectParams = rp = undefined;
        }
        if (rp && rp.serviceUrl !== url) {
            this.logger.warn("Dropping cached connection parameters for a different environment (" + rp.serviceUrl + ", now " + url + ")");
            this.reconnectParams = rp = undefined;
        }
        if (rp && rp.reconnectUrl) {
            url = rp.reconnectUrl;
        }
        if (rp) {
            // Do not append serviceUrl and reconnectUrl as query parameters
            connectParams = __assign({}, rp, { serviceUrl: undefined, reconnectUrl: undefined });
        }
        else {
            connectParams = null;
        }
        url = this.appendCorrelationIds(url, false);
        url = this.appendEndpointId(url, false);
        if (connectParams) {
            url += "&" + this.buildQuery(connectParams);
            // Currently server doesn't return "v" in allocate result, but it
            // can be changed, so implement it this way just in case
            if (!connectParams.v) {
                url += "&v=" + VERSION;
            }
        }
        var allocateRequest = new Request(url, {
            method: 'POST',
            mode: 'cors',
            headers: new Headers({
                'X-Skypetoken': token,
                'Content-Type': 'text/plain'
            })
        });
        this.logger.info("sendAllocateRequest: POST " + url);
        this.connectionTracker.trackStart('allocation');
        var startTimestamp = Date.now();
        var responseStatusCode = -1;
        Common_1.fetchWithTimeout(allocateRequest, this.timeoutOptions.fetchTimeoutMs).then(function (response) {
            responseStatusCode = response.status;
            if (!response.ok) {
                throw new Error(response.statusText);
            }
            // tslint:disable-next-line:no-backbone-get-set-outside-model
            var contentType = response.headers.get('content-type');
            if (!contentType || (contentType !== 'application/json' && contentType.substring(0, 17) !== 'application/json;')) {
                throw new Error("Content-type '" + contentType + "' is unexpected");
            }
            _this.connectionTracker.trackEnd('allocation');
            return response.json();
        }).then(function (responseObj) {
            _this.allocationErrorsInRow = 0;
            _this.unauthorizedErrorCount = 0;
            _this.onAllocationResponse(responseObj, serviceUrl);
        }).catch(function (error) {
            _this.allocationErrorsInRow++;
            var msg = error + ", status code " + responseStatusCode;
            _this.logger.error(_this.allocationErrorsInRow + " failed allocation attempt(s) in a row. Error: " + msg);
            _this.connectionTracker.trackError('allocation', msg);
            if (responseStatusCode === 401) {
                _this.unauthorizedErrorCount++;
            }
            if (!_this.canRetryTokenFetchRequest(_this.unauthorizedErrorCount)) {
                var errorMessage = 'getToken retry limit hit, reached terminal error state';
                _this.connectionTracker.trackError('allocation', errorMessage);
                _this.fsm.onTerminalError();
                return;
            }
            if (responseStatusCode === -1 && !_this.isNavigatorOnline) {
                _this.logger.info('Expected failure, the browser says it is not online at the moment');
            }
            else if (_this.reconnectParams && _this.allocationErrorsInRow >= 3) {
                if (responseStatusCode >= 400 && responseStatusCode <= 599) {
                    _this.logger.warn(_this.allocationErrorsInRow + " connection attempts, server-side failure: erasing cached connection parameters");
                    _this.reconnectParams = undefined;
                }
                else if (_this.reconnectParams.reconnectUrl && _this.allocationErrorsInRow % 3 === 0) {
                    _this.logger.warn(_this.allocationErrorsInRow + " connection attempts, testing nominal service URL");
                    // Make sure to finish the check before connection timeout passes to avoid unexpected FSM calls
                    var timeoutMs = Math.min(_this.timeoutOptions.connectionTimeoutMs - (Date.now() - startTimestamp) - 500, _this.timeoutOptions.fetchTimeoutMs);
                    _this.testNominalUrlConnectivity(timeoutMs)
                        .then(function (result) {
                        _this.connectionTracker.trackProgress('nomcheck', result ? 'ok' : 'failed');
                        if (result) {
                            _this.logger.warn('Nominal service URL is reachable, erasing cached reconnect URL');
                            if (_this.reconnectParams) {
                                delete _this.reconnectParams.reconnectUrl;
                            }
                        }
                        else {
                            _this.logger.warn('Nominal service URL is not reachable either, keeping cached reconnect URL');
                        }
                        _this.fsm.onAllocationFailed(false);
                    }, function (_) {
                        // Should not happen, but removes no-floating-promises warning
                        _this.fsm.onAllocationFailed(false);
                    });
                    return;
                }
            }
            _this.fsm.onAllocationFailed(responseStatusCode === 401);
        });
    };
    TrouterConnection.prototype.testNominalUrlConnectivity = function (timeoutMs) {
        var _this = this;
        if (timeoutMs < 1000) {
            this.logger.warn("There is no time left to reasonably perform the nominal service URL connectivity check (" + timeoutMs + " ms), falling back to assuming that the connectivity is fine");
            return es6_promise_1.Promise.resolve(true);
        }
        var testRequest;
        try {
            var url = new URL(this.options.trouterUrl);
            // Modify the URL to reach the root page (which returns a plain text string "Trouter")
            url.pathname = '/';
            // Add a few query parameters for possible classification and troubleshooting
            // tslint:disable-next-line:prefer-template readability
            url.search = '?' + this.buildQuery({
                check: Date.now(),
                cor_id: encodeURIComponent(this.options.clientCorrelationID),
                epid: encodeURIComponent(this.options.endpointId ? this.options.endpointId : ''),
                tc: encodeURIComponent(Common_1.toJson(this.clientInfo))
            });
            testRequest = new Request(url.toString(), {
                method: 'GET',
                headers: { Accept: 'text/plain' }
            });
        }
        catch (error) {
            this.logger.warn("Nominal service URL connectivity test request could not be created (" + error + "), falling back to assuming that the connectivity is fine");
            return es6_promise_1.Promise.resolve(true);
        }
        return Common_1.fetchWithTimeout(testRequest, timeoutMs)
            .then(function (response) {
            if (response.status !== 200) {
                throw new Error("Not 200 OK: " + response.status + " " + response.statusText);
            }
            return response.text();
        })
            .then(function (body) {
            if (body !== 'Trouter') {
                throw new Error("Not \"Trouter\": " + body.substring(0, 16) + (body.length > 16 ? '...' : ''));
            }
            return true;
        })
            .catch(function (error) {
            _this.logger.error("Nominal service URL connectivity test failed: " + error);
            return false;
        });
    };
    TrouterConnection.prototype.sendPingRequest = function () {
        var _this = this;
        if (this.socket && this.pingResponseTimerId === undefined) {
            try {
                this.logger.info('emitting ping event');
                var timeoutReached_1 = false;
                this.socket.emit('ping', function () {
                    if (timeoutReached_1 === true) {
                        return;
                    }
                    _this.onPingResponse();
                });
                this.pingResponseTimerId = setTimeout(function () {
                    _this.logger.error('Ping response timeout is fired');
                    timeoutReached_1 = true;
                    _this.clearPingResponseTimer();
                    _this.fsm.onPingResponseTimeout();
                }, this.timeoutOptions.pongTimeoutMs);
            }
            catch (error) {
                var msg = Common_1.toJson(error.stack);
                this.logger.error("unable to send ping. Error: " + msg);
                this.connectionTracker.trackError('ping', msg, false);
            }
        }
    };
    TrouterConnection.prototype.setUserActivityState = function (userActivityObject) {
        var changed = (userActivityObject.state !== this.userActivityState.state);
        this.userActivityState = userActivityObject;
        this.fsm.onSetUserActivityState(userActivityObject, changed);
    };
    TrouterConnection.prototype.sendUserActivityState = function (reason, connected) {
        if (this.userActivityState.state === Interfaces_1.UserActivityState.Unknown) {
            return;
        }
        if (this.transportTypeName === 'websocket' && connected) {
            if (reason === InternalInterfaces_1.UserActivityEventReason.Connected) {
                this.sendUserActivityStateMultiple(2);
            }
            else {
                this.sendUserActivityStateMultiple(1);
            }
        }
        else if (this.transportTypeName === 'xhr-polling') { // ignoring the connected flag
            if (reason === InternalInterfaces_1.UserActivityEventReason.Modified) {
                this.fsm.forceReconnect('user activity/force reconnect');
            }
        }
    };
    TrouterConnection.prototype.sendRegisterRequest = function () {
        var _this = this;
        if (!this.options.registration || !this.registrarClient) {
            throw new Error('Internal error - options.registration is undefined');
        }
        if (!this.allocateResult) {
            throw new Error('Allocate result is undefined in sendRegisterRequest()');
        }
        this.logger.info('sending register request');
        var span = new Common_1.Timespan();
        this.connectionTracker.trackStart('registration');
        var _a = this.getRegistrationTtl(), registrationTtl = _a[0], isRegistrationTtlLowerThanKnownAllocationTtl = _a[1];
        this.registrarClient.register({
            appId: this.options.registration.pnhAppId,
            aesKey: '',
            languageId: 'en-US',
            platform: this.options.registration.platform,
            templateKey: this.options.registration.pnhTemplateKey,
            platformUIVersion: this.options.registration.platformUIVersion,
            productContext: this.options.registration.productContext
        }, {
            TROUTER: [{
                    context: this.options.registration.context,
                    path: this.allocateResult.surl,
                    ttl: registrationTtl
                }]
        }).then(function () {
            _this.logger.info('Register request successful');
            _this.connectionTracker.trackEnd('registration');
            _this.fsm.onRegistrationSucceed(isRegistrationTtlLowerThanKnownAllocationTtl);
            _this.connectionTracker.sendTelemetry(ConnectionTracker_1.ClientEventName.Registration, {
                duration: span.duration
            }, []);
        }).catch(function (error) {
            _this.logger.error("Register request failed. Error: " + error);
            _this.connectionTracker.trackError('registration', error.message);
            _this.fsm.onRegistrationFailed(false); // Auth challenges are handled within tsregistrar
            _this.connectionTracker.sendTelemetry(ConnectionTracker_1.ClientEventName.Registration, {
                duration: span.duration
            }, []);
        });
    };
    TrouterConnection.prototype.sendUnregisterRequest = function () {
        var _this = this;
        this.logger.info('sending unregister request');
        var span = new Common_1.Timespan();
        if (!this.options.registration || !this.registrarClient) {
            throw new Error('Internal error - options.registration is undefined');
        }
        this.connectionTracker.trackStart('unregistration');
        this.registrarClient.unregister().then(function () {
            _this.logger.info('Unregister request successful');
            _this.connectionTracker.trackEnd('unregistration');
            _this.fsm.onUnregistrationSucceed();
            _this.connectionTracker.sendTelemetry(ConnectionTracker_1.ClientEventName.Unregistration, {
                duration: span.duration
            }, []);
        }).catch(function (error) {
            _this.logger.error("Unregister request failed. Error: " + error);
            _this.connectionTracker.trackError('unregistration', error.message);
            _this.fsm.onUnregistrationFailed(false);
            _this.connectionTracker.sendTelemetry(ConnectionTracker_1.ClientEventName.Unregistration, {
                duration: span.duration
            }, []);
        });
    };
    TrouterConnection.prototype.resetTokenBackoff = function () {
        this.tokenBackoff.reset();
    };
    TrouterConnection.prototype.resetRegisterBackoff = function () {
        if (this.registrarClient) {
            this.registrarClient.cancelPendingRequests();
        }
    };
    TrouterConnection.prototype.clearTimers = function () {
        this.logger.debug('Clearing all pending downstream events related timers');
        for (var _i = 0, _a = Object.keys(this.pendingTimers); _i < _a.length; _i++) {
            var key = _a[_i];
            this.clearTimer(Number(key));
        }
    };
    TrouterConnection.prototype.restartIncallModeTimer = function () {
        var _this = this;
        this.clearIncallModeTimerId();
        this.logger.debug('Restarting incall mode timer');
        this.incallModeTimerId = setTimeout(function () {
            _this.logger.info('Call mode timer fired');
            _this.fsm.onIncallModeTimer();
        }, this.options.incallModeTimeoutMs);
    };
    TrouterConnection.prototype.enterIncallMode = function () {
        this.logger.info('Entering incall mode');
        this.timeoutOptions = this.options.incallTimeoutOptions;
        this.tokenBackoff.setMaxBackoffMs(this.timeoutOptions.maxBackoffMs);
        // Uncomment to enable change of timeout in XHR mode - do it once server start to support it
        // if (this.socket) {
        //     this.socket.socket.options.query = this.buildSocketIoUrlParams();
        // }
        this.inIncallMode = true;
    };
    TrouterConnection.prototype.exitIncallMode = function () {
        this.logger.info('Exiting incall mode');
        this.clearIncallModeTimerId();
        this.timeoutOptions = this.options.timeoutOptions;
        this.tokenBackoff.setMaxBackoffMs(this.timeoutOptions.maxBackoffMs);
        // Uncomment to enable change of timeout in XHR mode - do it once server start to support it
        // if (this.socket) {
        //     this.socket.socket.options.query = this.buildSocketIoUrlParams();
        // }
        this.inIncallMode = false;
    };
    TrouterConnection.prototype.isIncallMode = function () {
        return this.inIncallMode;
    };
    TrouterConnection.prototype.sendDisconnectTelemetryEvent = function (reason) {
        var props = { reason: reason, serverClosed: !this.fsm.isActive() };
        this.connectionTracker.trackDisconnected(props);
        this.connectionTracker.clearConnectedInfo();
    };
    ////////// SocketIO callbacks //////////
    TrouterConnection.prototype.onSocketConnecting = function (transportTypeName) {
        this.logger.info("onSocketConnecting(" + transportTypeName + ")");
        this.transportTypeName = transportTypeName;
        this.connectionTracker.trackProgress('connecting', this.transportTypeName);
        this.fsm.onConnecting();
    };
    TrouterConnection.prototype.onSocketConnect = function () {
        this.logger.info('onSocketConnect');
    };
    TrouterConnection.prototype.onSocketConnectFailed = function (reason) {
        this.logger.error('onSocketConnectFailed');
        this.connectionTracker.trackError('connect_failed', reason, true, this.transportTypeName ? this.transportTypeName : this.UNKNOWN_TRANSPORT);
        this.fsm.onConnectingFailed();
    };
    TrouterConnection.prototype.onSocketDisconnect = function (reason) {
        this.logger.error("onSocketDisconnect, reason: " + reason);
        var sessionLengthMs = this.connectionTracker.getSessionLength() || 0;
        if (reason === 'dup' && this.lastDisconnectReason === 'dup' &&
            sessionLengthMs < this.options.duplicateDisconnectThresholdMs) {
            this.logger.warn('Socket was closed by server as Duplicate for the second time in a row ' +
                ("after " + sessionLengthMs + " ms which is below the threshold of ") +
                (this.options.duplicateDisconnectThresholdMs + " ms. Resetting cached ") +
                'connection parameters and making a new allocation.');
            this.reconnectParams = undefined;
        }
        this.lastDisconnectReason = reason;
        this.fsm.onSocketDisconnect(reason);
        this.connectionExpireTimestampInSecs = undefined;
    };
    TrouterConnection.prototype.onSocketReconnect = function () {
        // this callback should not be called, because reconnect on socket.io is disabled, but
        // leave it here in case error in socket.io
        this.logger.error('onSocketReconnect');
        this.fsm.onTrouterConnected();
    };
    TrouterConnection.prototype.onSocketReconnectFailed = function (reason) {
        // this callback should not be called, because reconnect on socket.io is disabled, but
        // leave it here in case error in socket.io
        this.logger.error("onSocketReconnectFailed with '" + reason + "'");
        this.fsm.onSocketDisconnect(typeof reason === 'string' ? reason : undefined);
    };
    TrouterConnection.prototype.onSocketReconnecting = function () {
        // this callback should not be called, because reconnect on socket.io is disabled, but
        // leave it here in case error in socket.io
        this.logger.error('onSocketReconnecting');
    };
    TrouterConnection.prototype.onSocketError = function (errorObject) {
        this.logger.error("onSocketError with '" + Common_1.toJson(errorObject) + "'");
        this.connectionTracker.trackError('connectSocket', errorObject);
        this.fsm.onSocketDisconnect(typeof errorObject === 'string' ? errorObject : undefined);
    };
    TrouterConnection.prototype.onSocketMessage = function (requestJson) {
        var _this = this;
        this.logger.info('onSocketMessage');
        var request;
        try {
            request = new TrouterRequest(requestJson);
            var chainId = request.headers && request.headers['X-Microsoft-Skype-Chain-ID'];
            var chainIdLogText = chainId ? " Chain-Id " + chainId : '';
            this.logger.info("Received request N " + request.id + chainIdLogText + " CV " + request.correlationVector + " to '" + request.url + "'");
            request.startTS = Date.now();
            if (request.url && this.urlPath && request.url.indexOf(this.urlPath) === 0) {
                request.shortUrl = request.url.substring(this.urlPath.length);
            }
        }
        catch (error) {
            var msg = Common_1.toJson(error.stack);
            this.logger.error("unable to parse request. Error: " + msg);
            this.connectionTracker.trackRequest(undefined, msg);
            this.connectionTracker.sendResponseError("unable to parse request, error: " + error);
            return;
        }
        request.timeoutTimerId = setTimeout(function () {
            if (request.replied) {
                return;
            }
            _this.logger.error("Request " + request.id + " timed out");
            var responseData = new ConnectionTracker_1.ResponseData(request.id);
            responseData.status = 504;
            responseData.headers = { 'Trouter-Responder': 'ClientLib' };
            _this.sendResponse(request, responseData);
            request.timedout = true;
        }, this.timeoutOptions.requestTimeoutMs);
        try {
            this.connectionTracker.trackRequest(request);
            this.fsm.onDownstreamRequest(request);
        }
        catch (error) {
            this.logger.error("exception in socket.on message. Error: " + Common_1.toJson(error.stack));
            this.connectionTracker.sendResponseError(error.message, request, undefined);
        }
    };
    TrouterConnection.prototype.onTrouterConnected = function (eventArgs) {
        if (!this.allocateResult) {
            this.logger.error('Invalid internal state - received onTrouterConnected while allocateResult is not set');
            return;
        }
        this.logger.info("onTrouterConnected: " + this.allocateResult.url);
        // Prevent next 'trouter.connected' responses from other trouter nodes
        // hackish way, since socket.io doesn't have API for that
        if (this.socket && this.socket.socket && this.socket.socket.options && this.socket.socket.options.query) {
            this.socket.socket.options.query += '&connected=true';
        }
        // Strip off the first part of the URL, up to the path
        this.urlPath = this.allocateResult.url.replace(/https?:\/\/([A-z0-9\:\$\-\_\.\+\!\*\"\(\)\,]*)\//, '/');
        var isNewUrl = (this.connectedUrl !== this.allocateResult.url);
        this.connectedUrl = this.allocateResult.url;
        this.connectionExpireTimestampInSecs = Common_1.calculateExpireTsInSec(eventArgs.ttl);
        this.connectionTracker.trackEnd('connectSocket');
        this.connectionTracker.trackConnected(isNewUrl, this.transportTypeName ? this.transportTypeName : this.UNKNOWN_TRANSPORT);
        this.fsm.onTrouterConnected();
    };
    TrouterConnection.prototype.onTrouterReconnect = function (eventArgs) {
        var target = eventArgs.target;
        this.logger.info("onTrouterReconnect target: " + target);
        if (target === 'self') {
            this.fsm.onReconnectRequired(true, ReconnectReason.ServerInitiated);
        }
        else {
            this.fsm.onReconnectRequired(false, ReconnectReason.ServerInitiated);
        }
    };
    TrouterConnection.prototype.onTrouterMessageLoss = function (eventArgs) {
        this.logger.info('onTrouterMessageLoss');
        // Send only array of tags for further processing
        this.fsm.onTrouterMessageLost(eventArgs.droppedIndicators);
    };
    ////////// Other functions //////////
    TrouterConnection.prototype.onNavigatorOnlineStatusUpdate = function (e) {
        var state = window.navigator.onLine;
        this.logger.debug("Browser online status update - new state: " + state + ", previously: " + this.isNavigatorOnline);
        if (state && !this.isNavigatorOnline) {
            this.isNavigatorOnline = true;
            this.tokenBackoff.expediteIfPending();
            this.connectionTracker.trackProgress('browserNet', 'online');
        }
        else if (!state && this.isNavigatorOnline) {
            this.isNavigatorOnline = false;
            this.connectionTracker.trackProgress('browserNet', 'offline');
        }
    };
    TrouterConnection.prototype.onAllocationResponse = function (allocateResult, serviceUrl) {
        this.logger.info("Received allocation response " + JSON.stringify(allocateResult));
        this.allocateResult = allocateResult;
        this.reconnectParams = __assign({ serviceUrl: serviceUrl, 
            // The service does not send reconnectUrl (yet), make it up based
            // on other fields - 'socketio' is simply the root
            reconnectUrl: this.allocateResult.socketio + "v4/a" }, allocateResult.connectparams);
        // in V4 ttl is a string in IAllocateResult - converting it to number with "+"
        var ttl = +allocateResult.ttl;
        // Don't use allocateResult.connectparams.se here since system clock can be
        // incorrect on client's machine, so using TTL is safer
        this.connectionExpireTimestampInSecs = Common_1.calculateExpireTsInSec(ttl);
        this.connectionId = this.allocateResult.id || '';
        this.connectedClientId = this.allocateResult.ccid;
        this.logger.info("connected client id set {connectedClientId:" + this.connectedClientId + "}");
        this.c2cUrlBase = allocateResult.curlb || '';
        if (this.c2cUrlBase === '') {
            // Try to just remove the port as a fallback if the service didn't provide anything
            var pos = allocateResult.surl.indexOf('://');
            if (pos >= 0) {
                pos = allocateResult.surl.indexOf('/', pos + 3);
                if (pos >= 5 && allocateResult.surl.substr(pos - 5, 5) === ':3443') {
                    this.c2cUrlBase = allocateResult.surl.substr(0, pos - 5);
                }
            }
        }
        // tslint:disable-next-line:no-non-null-assertion cannot be null, was set earlier
        this.manager.onConnectionParametersUpdated(this.reconnectParams);
        this.fsm.onAllocationSucceed();
    };
    TrouterConnection.prototype.onPingResponse = function () {
        this.logger.info('onPingResponse');
        this.connectionTracker.increasePingResponseCount();
        this.clearPingResponseTimer();
        this.fsm.onPingResponse();
    };
    TrouterConnection.prototype.clearPingResponseTimer = function () {
        if (this.pingResponseTimerId !== undefined) {
            clearTimeout(this.pingResponseTimerId);
            this.pingResponseTimerId = undefined;
        }
    };
    TrouterConnection.prototype.buildQuery = function (map) {
        // TO-DO: Replace this and all other similar functions around with URLSearchParams
        var components = [];
        for (var _i = 0, _a = Object.keys(map); _i < _a.length; _i++) {
            var i = _a[_i];
            if (map.hasOwnProperty(i) && map[i] !== undefined) {
                components.push(i + "=" + map[i]);
            }
        }
        return components.join('&');
    };
    TrouterConnection.prototype.appendConnectedClientIds = function (url, isParamsOnly) {
        var params = '';
        if (url.indexOf('ccid=') < 0) {
            params = "ccid=" + this.connectedClientId + "&";
        }
        if (this.domId) {
            params += "dom=" + this.domId + "&";
        }
        if (params.length > 0) {
            params = params.slice(0, -1);
        }
        var sep = (isParamsOnly || url.indexOf('?') !== -1) ? ('&') : ('?');
        return this.appendCorrelationIds(url + sep + params, isParamsOnly);
    };
    TrouterConnection.prototype.appendEndpointId = function (url, isParamsOnly) {
        var sep = (isParamsOnly || url.indexOf('?') !== -1) ? ('&') : ('?');
        return (url.indexOf('epid') < 0 && this.options.endpointId)
            ? "" + url + sep + "epid=" + this.options.endpointId
            : url;
    };
    TrouterConnection.prototype.appendCorrelationIds = function (url, isParamsOnly) {
        var sep = (isParamsOnly || url.indexOf('?') !== -1) ? ('&') : ('?');
        return (url.indexOf('cor_id') < 0)
            ? "" + url + sep + "cor_id=" + this.options.clientCorrelationID
                + ("&con_num=" + this.clientID + "_" + this.connectionAttempt)
            : url;
    };
    TrouterConnection.prototype.safeString = function (str) {
        return (typeof (str) === 'string') ? str : '';
    };
    TrouterConnection.prototype.sendResponse = function (request, responseData) {
        if (request.timedout) {
            this.logger.error("Request " + request.id + " already timed out");
            return 1 /* Timeout */;
        }
        if (request.replied) {
            this.logger.error("Response for request " + request.id + " already sent");
            return 2 /* Duplicate */;
        }
        clearTimeout(request.timeoutTimerId);
        request.timeoutTimerId = 0;
        request.replied = true;
        responseData.headers = responseData.headers || {};
        var cv = request.correlationVector;
        this.logger.info("Sending response for request N " + request.id + " CV " + cv + " with status " + responseData.status);
        if (cv) {
            responseData.headers[cvHeader] = cv;
        }
        // Echo back the incoming "trouter-request" header
        if (request.headers && request.headers['trouter-request'] && !responseData.headers['trouter-request']) {
            responseData.headers['trouter-request'] = request.headers['trouter-request'];
        }
        // Fill in "trouter-client" header
        var latencyMS = Date.now() - request.startTS;
        responseData.headers['trouter-client'] = Common_1.toJson({
            cd: latencyMS
        });
        this.logger.debug("response: " + Common_1.toJson(responseData));
        if (this.socket) {
            try {
                this.socket.send(Common_1.toJson(responseData));
                responseData.sentTS = Date.now();
                request.incrementCorrelationVector();
                this.connectionTracker.trackResponse(request, latencyMS, responseData);
                if (this.transportTypeName === 'websocket') {
                    // Send ping request immediately to emulate 'ack' from server, so
                    // client can faster react on network issues
                    this.sendPingRequest();
                }
                return 0 /* OK */;
            }
            catch (error) {
                var errorMsg = "unable to send data on response.end. Error: " + Common_1.toJson(error.stack);
                this.logger.error(errorMsg);
                this.connectionTracker.sendResponseError(errorMsg, request, responseData);
                return 4 /* Disconnected */;
            }
        }
        else {
            this.connectionTracker.sendResponseError('no socket', request, responseData);
            return 4 /* Disconnected */;
        }
    };
    /*
        Sends the activity state event to Trouter.
        Has implemented support for sending the current state twice (or multiple times)
        after reconnect, first immediately, and theen the second after configured delay.

        If after the first sent state event the client app changes the state,
        the new state is sent in the second event after the delay.
        Meanwhile the new state is also sent immediately upon
        the change, but the planned second sending (after delay) is triggered anyway,
        to fulfill it's purpose, which is to prevent server-side race condition.
     */
    TrouterConnection.prototype.sendUserActivityStateMultiple = function (remaining) {
        var _this = this;
        var activityEvent = new DownstreamEvent('user.activity');
        var activityEventObject = this.userActivityState.toEventObject();
        activityEvent.args = activityEventObject;
        this.userActivityState.correlationVector.increase();
        this.logger.debug("Sending user activity '" + this.userActivityState.toEventJSON() + "', remaining " + (remaining - 1));
        var timeoutReached = false;
        this.sendDownstreamEvent(activityEvent, function () {
            if (timeoutReached === true) {
                return;
            }
            _this.logger.info("User activity state: " + activityEventObject.state + ", cv: " + activityEventObject.cv + " accepted");
            if (_this.manager.onUserActivityStateAccepted) {
                _this.manager.onUserActivityStateAccepted(activityEventObject.cv);
            }
            _this.clearTimer(activityEvent.timeoutTimerId);
            if (remaining > 1) {
                var timerId_1 = setTimeout(function () {
                    _this.clearTimer(timerId_1);
                    _this.sendUserActivityStateMultiple(remaining - 1);
                }, _this.options.userActivitySecondResendDelayMs);
                _this.registerTimer(timerId_1, 'user.activity/resend');
            }
        });
        activityEvent.timeoutTimerId = setTimeout(function () {
            _this.logger.error('Activity state response timeout is fired');
            timeoutReached = true;
            _this.fsm.onActivityStateResponseTimeout();
            _this.clearTimer(activityEvent.timeoutTimerId);
        }, this.timeoutOptions.userActivityResponseTimeoutMs);
        this.registerTimer(activityEvent.timeoutTimerId, 'user.activity/response');
    };
    TrouterConnection.prototype.sendDownstreamEvent = function (event, responseCallback) {
        this.logger.info("Sending downstream event " + event.name);
        if (this.socket) {
            this.socket.emit(event.name, event.args, responseCallback);
        }
    };
    TrouterConnection.prototype.registerTimer = function (timerId, timerDescription) {
        this.logger.debug("registering timer " + timerId + " -> " + timerDescription);
        this.pendingTimers[timerId] = timerDescription;
    };
    TrouterConnection.prototype.clearTimer = function (id) {
        var timerDescription = this.pendingTimers[id];
        this.logger.debug("clearing timer " + id + " -> " + timerDescription);
        delete this.pendingTimers[id];
        clearTimeout(id);
    };
    /**
     * Calculate registration interval. Result is based on configuration parameters
     * and allocation ttl value from trouter server.
     * Returns true only if the registration ttl is present and is smaller than known `allocationTtl`.
     * This means we'll need to re-register to keep the registration alive for the duration of the allocation.
     */
    TrouterConnection.prototype.getRegistrationTtl = function () {
        var allocationTtl = Common_1.calculateTtlInSec(this.connectionExpireTimestampInSecs);
        this.logger.debug("Current connectionID will expire in " + allocationTtl + " seconds");
        if (this.options.registration && this.options.registration.registrarTtlSec && allocationTtl > 0) {
            var isLower = this.options.registration.registrarTtlSec < allocationTtl;
            return [Math.min(this.options.registration.registrarTtlSec, allocationTtl), isLower];
        }
        else if (this.options.registration && this.options.registration.registrarTtlSec) {
            return [this.options.registration.registrarTtlSec, false];
        }
        else if (allocationTtl > 0) {
            return [allocationTtl, false];
        }
        return [DEFAULT_REGISTRATION_TIMEOUT_SEC, false];
    };
    TrouterConnection.prototype.clearIncallModeTimerId = function () {
        if (this.incallModeTimerId !== undefined) {
            this.logger.debug('Clearing in-call mode timer');
            clearTimeout(this.incallModeTimerId);
            this.incallModeTimerId = undefined;
        }
    };
    TrouterConnection.prototype.applyConnectionTrackerOptions = function (options) {
        try {
            var eventLoggerSent = (options.eventLogger && typeof options.eventLogger.logEvent === 'function');
            if (!eventLoggerSent) {
                this.logger.warn('Trouter client event logging disabled due to invalid configuration.');
            }
            else {
                this.connectionTracker.mergeSettings(options.telemetrySettings);
                this.connectionTracker.enable(options.eventLogger);
            }
        }
        catch (error) {
            this.logger.warn("Trouter client event logging disabled. Error: " + Common_1.toJson(error.stack));
            this.connectionTracker.disable();
        }
    };
    /**
     * Returns boolean indicating if we can retry token fetch
     * based on value of optional configuration 'retryLimitOnTokenFetch'
     * @returns boolean
     */
    TrouterConnection.prototype.canRetryTokenFetchRequest = function (currentCounter) {
        var retryLimit = this.options.retryLimitOnTokenFetch;
        if (retryLimit === null || retryLimit === undefined) {
            return true;
        }
        if (currentCounter < retryLimit) {
            return true;
        }
        this.logger.warn("Reached limit on maximum number of token fetch request. Current count: " + currentCounter + ", retry limit: " + retryLimit);
        return false;
    };
    return TrouterConnection;
}());
exports.TrouterConnection = TrouterConnection;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:export-name
var Constants_1 = __webpack_require__(1);
/**
 * Registry of message handlers.
 * Safely executes individual handlers and aggregates results
 */
var MessageHandlerRegistry = /** @class */ (function () {
    function MessageHandlerRegistry(logger) {
        this.logger = logger;
        this.messageHandlers = [];
    }
    MessageHandlerRegistry.prototype.register = function (handler) {
        if (this.messageHandlers.some(function (item) { return item === handler; })) {
            throw new Error('Registering the same handler twice is not allowed');
        }
        this.messageHandlers.push(handler);
    };
    MessageHandlerRegistry.prototype.clear = function () {
        this.logger.debug('Clearing message handlers');
        this.messageHandlers = [];
    };
    MessageHandlerRegistry.prototype.active = function () {
        return (this.messageHandlers.length > 0);
    };
    MessageHandlerRegistry.prototype.handleMessage = function (message) {
        var unhandledMessageResult = {
            resultCode: Constants_1.UNHANDLED_MESSAGE_ACK,
            isHandled: false
        };
        for (var _i = 0, _a = this.messageHandlers; _i < _a.length; _i++) {
            var messageHandler = _a[_i];
            var result = this.safeExecuteHandle(messageHandler, message);
            if (result !== undefined && (result.isHandled === undefined || result.isHandled)) {
                if (result.resultCode === undefined) {
                    result.resultCode = Constants_1.HANDLED_MESSAGE_ACK;
                }
                return result;
            }
        }
        return unhandledMessageResult;
    };
    MessageHandlerRegistry.prototype.safeExecuteHandle = function (handler, message) {
        try {
            return handler.handleMessage(message);
        }
        catch (exception) {
            this.logger.warn("A trouter message handler is throwing exceptions. exception: " + exception);
            return undefined;
        }
    };
    return MessageHandlerRegistry;
}());
exports.MessageHandlerRegistry = MessageHandlerRegistry;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable-next-line:export-name
function addCacheAsBackupTo(provider) {
    var _this = this;
    var cachedToken;
    return function (forceRefresh) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (forceRefresh) {
                cachedToken = undefined;
            }
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    provider(forceRefresh).then(function (token) {
                        cachedToken = token;
                        resolve(token);
                    }).catch(function (error) {
                        if (cachedToken !== undefined && cachedToken.length > 0) {
                            resolve(cachedToken);
                        }
                        reject(error);
                    });
                })];
        });
    }); };
}
exports.addCacheAsBackupTo = addCacheAsBackupTo;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:strict-boolean-expressions
// tslint:disable:promise-function-async
var Common_1 = __webpack_require__(3);
var Interfaces_1 = __webpack_require__(2);
var Logger_1 = __webpack_require__(0);
var TrouterConnection_1 = __webpack_require__(6);
var TrouterManagerFsm_1 = __webpack_require__(18);
/**
 * UserActivity object
 */
var UserActivityObject = /** @class */ (function () {
    function UserActivityObject(state, correlationVector) {
        this.state = state;
        this.correlationVector = correlationVector !== undefined ? correlationVector : Common_1.CorrelationVector.extend();
    }
    UserActivityObject.prototype.getStateString = function () {
        switch (this.state) {
            case Interfaces_1.UserActivityState.Active: return 'active';
            case Interfaces_1.UserActivityState.Inactive: return 'inactive';
            case Interfaces_1.UserActivityState.Unknown: return 'unknown';
            default: return 'undefined';
        }
    };
    UserActivityObject.prototype.toEventObject = function () {
        return { state: this.getStateString(), cv: this.correlationVector.value() };
    };
    UserActivityObject.prototype.toEventJSON = function () {
        return Common_1.toJson(this.toEventObject());
    };
    return UserActivityObject;
}());
exports.UserActivityObject = UserActivityObject;
/**
 * Trouter implementation
 */
var TrouterManager = /** @class */ (function () {
    function TrouterManager(logFunc, options, tokenProvider, listener) {
        this.logFunc = logFunc;
        this.options = options;
        this.tokenProvider = tokenProvider;
        this.listener = listener;
        this.logger = new Logger_1.Logger('Manager', logFunc);
        this.logger.info("Created TrouterManager with options " + Common_1.toJson(this.options));
        this.fsm = new TrouterManagerFsm_1.TrouterManagerFsm(logFunc, this);
        this.baseEndpointUrl = '';
        this.processedMessageLoss = {};
        this.userActivityObject = new UserActivityObject(Interfaces_1.UserActivityState.Unknown);
    }
    TrouterManager.prototype.start = function () {
        this.fsm.start();
    };
    TrouterManager.prototype.stop = function (dontUnregister) {
        this.fsm.stop(dontUnregister);
    };
    TrouterManager.prototype.configure = function (options) {
        this.options = options;
        if (this.firstConnection !== undefined) {
            this.firstConnection.configure(options);
        }
        if (this.secondConnection !== undefined) {
            this.secondConnection.configure(options);
        }
        this.logger.info("Reconfigured TrouterManager with options " + Common_1.toJson(this.options));
    };
    TrouterManager.prototype.checkConnection = function (disconnectDetected) {
        if (this.firstConnection !== undefined) {
            this.firstConnection.checkConnection(disconnectDetected);
        }
        if (this.secondConnection !== undefined) {
            this.secondConnection.checkConnection(disconnectDetected);
        }
    };
    TrouterManager.prototype.resendRegistration = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.secondConnection !== undefined) {
                    this.logger.info('Resending registration on the second/new connection');
                    return [2 /*return*/, this.secondConnection.resendRegistration()];
                }
                if (this.firstConnection !== undefined) {
                    this.logger.info('Resending registration on the first/current connection');
                    return [2 /*return*/, this.firstConnection.resendRegistration()];
                }
                this.logger.info('No connection to resend registration on, will be done upon (re)connect');
                return [2 /*return*/];
            });
        });
    };
    TrouterManager.prototype.getServerState = function () {
        if (this.firstConnection !== undefined) {
            return this.firstConnection.getServerState();
        }
        return undefined;
    };
    /** Returns current state */
    TrouterManager.prototype.getState = function () {
        return this.fsm.getState();
    };
    //////////// IManagerWorker ////////////
    TrouterManager.prototype.startFirstConnection = function () {
        var connection = new TrouterConnection_1.TrouterConnection(this.logFunc, this.options, this, this.tokenProvider, this.userActivityObject);
        this.firstConnection = connection;
        this.getConnectionCache()
            .then(function (connectionCache) {
            connection.start(connectionCache);
        })
            .catch();
    };
    TrouterManager.prototype.startSecondConnection = function (useConnectParamsFromCache) {
        var connection = new TrouterConnection_1.TrouterConnection(this.logFunc, this.options, this, this.tokenProvider, this.userActivityObject);
        this.secondConnection = connection;
        if (this.firstConnection !== undefined) {
            this.firstConnection.disableRegistrationsAndAutoReconnect();
        }
        if (useConnectParamsFromCache) {
            this.getConnectionCache()
                .then(function (connectionCache) {
                connection.start(connectionCache);
            })
                .catch();
        }
        else {
            connection.start();
        }
    };
    TrouterManager.prototype.stopFirstConnection = function (dontUnregister) {
        if (this.firstConnection !== undefined) {
            // Store first connection to be able to compare in onDisconnected() handler
            this.storedFirstConnection = this.firstConnection;
            this.firstConnection.stop(dontUnregister);
            this.firstConnection = undefined;
        }
    };
    TrouterManager.prototype.stopSecondConnection = function (dontUnregister) {
        if (this.secondConnection !== undefined) {
            this.secondConnection.stop(dontUnregister);
            this.secondConnection = undefined;
        }
    };
    TrouterManager.prototype.stopSecondConnectionDelayed = function () {
        if (this.secondConnection !== undefined) {
            var connection_1 = this.secondConnection;
            this.secondConnection = undefined;
            this.logger.info("Closing an inactive connection in " + Math.round(this.options.lingeringConnectionDelayMs / 1000) + "s");
            setTimeout(function () {
                connection_1.stop(true);
            }, this.options.lingeringConnectionDelayMs);
        }
    };
    TrouterManager.prototype.forceStopLingeringConnection = function () {
        if (this.storedFirstConnection) {
            this.storedFirstConnection.stop(false);
            this.storedFirstConnection = undefined;
        }
    };
    TrouterManager.prototype.switchConnections = function () {
        var tmp = this.firstConnection;
        this.firstConnection = this.secondConnection;
        this.secondConnection = tmp;
    };
    TrouterManager.prototype.doesSecondConnectionExist = function () {
        return this.secondConnection !== undefined;
    };
    TrouterManager.prototype.dispatchConnected = function () {
        if (this.firstConnection !== undefined) {
            var ss = this.firstConnection.getServerState();
            var baseEndpointUrl = (ss.url.slice(-1) === '/') ? ss.url.slice(0, -1) : ss.url;
            var connectionInfo = {
                baseEndpointUrl: baseEndpointUrl,
                newEndpointUrl: (baseEndpointUrl !== this.baseEndpointUrl),
                c2cUrlBase: ss.c2cUrlBase,
                clientId: ss.connectedClientId,
                connectionId: ss.connectionId,
                connectionTtlSec: ss.getRemainingTtlInSec()
            };
            this.baseEndpointUrl = baseEndpointUrl;
            this.listener.onTrouterConnected(ss.url, connectionInfo);
        }
    };
    TrouterManager.prototype.dispatchReconnecting = function () {
        if (this.listener.onTrouterDisconnected) {
            this.listener.onTrouterDisconnected();
        }
    };
    TrouterManager.prototype.dispatchStopped = function () {
        if (this.listener.onTrouterDisconnected) {
            this.listener.onTrouterDisconnected();
        }
    };
    TrouterManager.prototype.dispatchRegistrationState = function (isRegistered) {
        if (this.options.registrationStateCallback) {
            this.options.registrationStateCallback(isRegistered);
        }
    };
    //////////// IManagerConsumer ////////////
    TrouterManager.prototype.onDownstreamRequest = function (connection, request, response) {
        var req = {
            id: request.id,
            method: request.method,
            path: "/" + request.shortUrl,
            body: request.body,
            headers: request.headers
        };
        var rsp = {
            id: request.id,
            status: 0,
            headers: {},
            body: '',
            send: function () {
                if (rsp.status <= 100 || rsp.status >= 999) {
                    return 3 /* Incomplete */;
                }
                response.writeHead(rsp.status, rsp.headers);
                return response.end(rsp.body);
            }
        };
        this.listener.onTrouterRequest(req, rsp);
    };
    TrouterManager.prototype.onConnected = function (connection) {
        this.fsm.onConnected(connection === this.firstConnection);
    };
    TrouterManager.prototype.onRegistered = function (connection) {
        this.fsm.onRegistered(connection === this.firstConnection);
    };
    TrouterManager.prototype.onUnregistered = function (connection) {
        this.fsm.onUnregistered(connection === this.firstConnection || connection === this.storedFirstConnection);
    };
    TrouterManager.prototype.onReconnecting = function (connection) {
        this.fsm.onReconnecting(connection === this.firstConnection);
    };
    TrouterManager.prototype.onReconnectIsRequired = function (connection, useConnectParamsFromCache, reason) {
        this.fsm.onReconnectionRequired(connection === this.firstConnection, useConnectParamsFromCache, reason);
    };
    TrouterManager.prototype.onDisconnected = function (connection) {
        this.fsm.onDisconnected(connection === this.storedFirstConnection);
        this.storedFirstConnection = undefined;
    };
    TrouterManager.prototype.onUserActivityStateAccepted = function (cv) {
        if (this.listener.onTrouterUserActivityStateAccepted) {
            this.listener.onTrouterUserActivityStateAccepted(cv);
        }
    };
    TrouterManager.prototype.onConnectionParametersUpdated = function (connectionParameters) {
        this.setConnectionCache(connectionParameters);
    };
    TrouterManager.prototype.setUserActivityState = function (state, correlationVector) {
        this.userActivityObject = new UserActivityObject(state, Common_1.CorrelationVector.extend(correlationVector));
        if (this.secondConnection !== undefined) {
            this.logger.info("Setting user activity " + this.userActivityObject.toEventJSON() + " on the second/new connection");
            this.secondConnection.setUserActivityState(this.userActivityObject);
            return;
        }
        if (this.firstConnection !== undefined) {
            this.logger.info("Setting user activity " + this.userActivityObject.toEventJSON() + " on the first/current connection");
            this.firstConnection.setUserActivityState(this.userActivityObject);
            return;
        }
    };
    TrouterManager.prototype.onTrouterMessageLost = function (indicators) {
        var _this = this;
        if (this.listener.onTrouterMessageLoss) {
            if (indicators && indicators.length) {
                // Filter out already seen dropped indicators and inform server that they are processed
                var duplicates = indicators.filter(function (di) { return _this.processedMessageLoss[di.tag + "-" + di.etag] !== undefined; });
                if (duplicates.length) {
                    this.logger.warn('onTrouterMessageLoss - removing duplicates and sending event to server');
                    this.sendProcessedDroppedIndicators(duplicates);
                    indicators = indicators.filter(function (di) { return _this.processedMessageLoss[di.tag + "-" + di.etag] === undefined; });
                    if (!indicators.length) {
                        this.logger.warn('onTrouterMessageLoss - All the data are duplicated');
                        return;
                    }
                }
                // Send the data to the listeners
                var messageLossProcessed = this.listener.onTrouterMessageLoss(indicators.map(function (di) { return di.tag; }));
                if (!messageLossProcessed) {
                    this.logger.warn('onTrouterMessageLoss - flow tags have not been processed by listeners');
                    return;
                }
                // Update the cache
                indicators.forEach(function (di) {
                    _this.processedMessageLoss[di.tag + "-" + di.etag] = '';
                });
                this.sendProcessedDroppedIndicators(indicators);
            }
            else {
                this.logger.warn('onTrouterMessageLoss - no flow tags have been provided');
            }
        }
    };
    TrouterManager.prototype.getConnectionCache = function () {
        var _this = this;
        if (!this.options.connectionCache) {
            return Promise.resolve(this.connectionCache);
        }
        this.logger.debug('Querying host\'s connection cache');
        return this.options.connectionCache.onGetTrouterConnectionCache()
            .then(function (serialized) {
            return serialized ? JSON.parse(serialized) : undefined;
        })
            .catch(function (e) {
            _this.logger.warn("Invalid connection cache content provided: " + e);
            return _this.connectionCache;
        });
    };
    TrouterManager.prototype.setConnectionCache = function (content) {
        this.connectionCache = content;
        if (this.options.connectionCache) {
            try {
                this.options.connectionCache.onSetTrouterConnectionCache(JSON.stringify(content));
            }
            catch (e) {
                this.logger.warn("Error setting external connection cache: " + e);
            }
        }
    };
    TrouterManager.prototype.sendProcessedDroppedIndicators = function (messageLossIndicators) {
        if (this.firstConnection !== undefined) {
            this.firstConnection.sendProcessedDroppedIndicators(messageLossIndicators);
            return;
        }
        if (this.secondConnection !== undefined) {
            this.secondConnection.sendProcessedDroppedIndicators(messageLossIndicators);
            return;
        }
    };
    return TrouterManager;
}());
exports.TrouterManager = TrouterManager;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Util that encapsulates lifecycle of active trouter URL and manages waiter for the URL via promise
 */
var TrouterUrlPromise = /** @class */ (function () {
    function TrouterUrlPromise(logger) {
        this.logger = logger;
    }
    // tslint:disable-next-line:promise-function-async
    TrouterUrlPromise.prototype.getPromise = function () {
        var _this = this;
        if (this.url !== undefined) {
            this.logger.debug("[TrouterUrlPromise] returning previously resolved url: " + this.url);
            return Promise.resolve(this.url);
        }
        if (this.pendingPromise === undefined) {
            this.logger.debug('[TrouterUrlPromise] creating and returning promise');
            // tslint:disable-next-line:promise-must-complete
            this.pendingPromise = new Promise(function (resolve, reject) {
                _this.pendingPromiseResolveRef = resolve;
                _this.pendingPromiseRejectRef = reject;
            });
        }
        else {
            this.logger.debug('[TrouterUrlPromise] returning existing promise');
        }
        return this.pendingPromise;
    };
    TrouterUrlPromise.prototype.resolveUrl = function (url) {
        this.url = url;
        this.logger.debug("[TrouterUrlPromise] got url: " + this.url);
        var resolveCallback = this.pendingPromiseResolveRef;
        this.pendingPromise = undefined;
        this.pendingPromiseResolveRef = undefined;
        this.pendingPromiseRejectRef = undefined;
        if (resolveCallback !== undefined) {
            this.logger.debug('[TrouterUrlPromise] resolving promise');
            resolveCallback(url);
        }
    };
    TrouterUrlPromise.prototype.rejectUrl = function (error) {
        this.logger.debug('[TrouterUrlPromise] aborting');
        var rejectCallback = this.pendingPromiseRejectRef;
        this.url = undefined;
        this.pendingPromise = undefined;
        this.pendingPromiseResolveRef = undefined;
        this.pendingPromiseRejectRef = undefined;
        if (rejectCallback !== undefined) {
            this.logger.debug('[TrouterUrlPromise] rejecting promise');
            rejectCallback(error);
        }
    };
    TrouterUrlPromise.prototype.resetUrl = function () {
        this.logger.debug('[TrouterUrlPromise] resetting url');
        this.url = undefined;
    };
    return TrouterUrlPromise;
}());
exports.TrouterUrlPromise = TrouterUrlPromise;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/** Socket.IO.js build:0.9.6, development. Copyright(c) 2011 LearnBoost <dev@learnboost.com> MIT Licensed */

/**
 * socket.io
 * Copyright(c) 2011 LearnBoost <dev@learnboost.com>
 * MIT Licensed
 */

(function (exports, global) {

  /**
   * IO namespace.
   *
   * @namespace
   */

  var io = exports;

  /**
   * Socket.IO version
   *
   * @api public
   */

  io.version = '0.9.6';

  /**
   * Protocol implemented.
   *
   * @api public
   */

  io.protocol = 1;

  /**
   * Available transports, these will be populated with the available transports
   *
   * @api public
   */

  io.transports = [];

  /**
   * Keep track of jsonp callbacks.
   *
   * @api private
   */

  io.j = [];

  /**
   * Keep track of our io.Sockets
   *
   * @api private
   */
  io.sockets = {};


  /**
   * Manages connections to hosts.
   *
   * @param {String} uri
   * @Param {Boolean} force creation of new socket (defaults to false)
   * @api public
   */

  io.connect = function (host, details) {
    var uri = io.util.parseUri(host)
      , uuri
      , socket;

    if (global && global.location) {
      uri.protocol = uri.protocol || global.location.protocol.slice(0, -1);
      uri.host = uri.host || (global.document
        ? global.document.domain : global.location.hostname);
      uri.port = uri.port || global.location.port;
    }

    uuri = io.util.uniqueUri(uri);

    var options = {
        host: uri.host
      , secure: 'https' == uri.protocol
      , port: uri.port || ('https' == uri.protocol ? 443 : 80)
      , query: uri.query || ''
    };

    io.util.merge(options, details);

    if (options['force new connection'] || !io.sockets[uuri]) {
      socket = new io.Socket(options);
    }

    if (!options['force new connection'] && socket) {
      io.sockets[uuri] = socket;
    }

    socket = socket || io.sockets[uuri];

    // if path is different from '' or /
    return socket.of(uri.path.length > 1 ? uri.path : '');
  };

})(
     true ? module.exports : (this.io = {})
  , 'undefined' === typeof global ? window : global);

// Workaround inside webpack
var io = module.exports;

/**
 * socket.io
 * Copyright(c) 2011 LearnBoost <dev@learnboost.com>
 * MIT Licensed
 */

(function (exports, global) {

  /**
   * Utilities namespace.
   *
   * @namespace
   */

  var util = exports.util = {};

  /**
   * Parses an URI
   *
   * @author Steven Levithan <stevenlevithan.com> (MIT license)
   * @api public
   */

  var re = /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;

  var parts = ['source', 'protocol', 'authority', 'userInfo', 'user', 'password',
               'host', 'port', 'relative', 'path', 'directory', 'file', 'query',
               'anchor'];

  util.parseUri = function (str) {
    var m = re.exec(str || '')
      , uri = {}
      , i = 14;

    while (i--) {
      uri[parts[i]] = m[i] || '';
    }

    return uri;
  };

  /**
   * Produces a unique url that identifies a Socket.IO connection.
   *
   * @param {Object} uri
   * @api public
   */

  util.uniqueUri = function (uri) {
    var protocol = uri.protocol
      , host = uri.host
      , port = uri.port;

    if ('document' in global) {
      host = host || document.domain;
      port = port || (protocol == 'https'
        && document.location.protocol !== 'https:' ? 443 : document.location.port);
    } else {
      host = host || 'localhost';

      if (!port && protocol == 'https') {
        port = 443;
      }
    }

    return (protocol || 'http') + '://' + host + ':' + (port || 80);
  };

  /**
   * Mergest 2 query strings in to once unique query string
   *
   * @param {String} base
   * @param {String} addition
   * @api public
   */

  util.query = function (base, addition) {
    var query = util.chunkQuery(base || '')
      , components = [];

    util.merge(query, util.chunkQuery(addition || ''));
    for (var part in query) {
      if (query.hasOwnProperty(part)) {
        components.push(part + '=' + query[part]);
      }
    }

    return components.length ? '?' + components.join('&') : '';
  };

  /**
   * Transforms a querystring in to an object
   *
   * @param {String} qs
   * @api public
   */

  util.chunkQuery = function (qs) {
    var query = {}
      , params = qs.split('&')
      , i = 0
      , l = params.length
      , kv;

    for (; i < l; ++i) {
      kv = params[i].split('=');
      if (kv[0]) {
        query[kv[0]] = kv[1];
      }
    }

    return query;
  };

  /**
   * Executes the given function when the page is loaded.
   *
   *     io.util.load(function () { console.log('page loaded'); });
   *
   * @param {Function} fn
   * @api public
   */

  var pageLoaded = false;

  util.load = function (fn) {
    if ('document' in global && document.readyState === 'complete' || pageLoaded) {
      return fn();
    }

    util.on(global, 'load', fn, false);
  };

  /**
   * Adds an event.
   *
   * @api private
   */

  util.on = function (element, event, fn, capture) {
    if (element.attachEvent) {
      element.attachEvent('on' + event, fn);
    } else if (element.addEventListener) {
      element.addEventListener(event, fn, capture);
    }
  };

  /**
   * Generates the correct `XMLHttpRequest` for regular and cross domain requests.
   *
   * @param {Boolean} [xdomain] Create a request that can be used cross domain.
   * @returns {XMLHttpRequest|false} If we can create a XMLHttpRequest.
   * @api private
   */

  util.request = function (xdomain) {

    if (xdomain && 'undefined' != typeof XDomainRequest) {
      return new XDomainRequest();
    }

    if ('undefined' != typeof XMLHttpRequest && (!xdomain || util.ua.hasCORS)) {
      return new XMLHttpRequest();
    }

    if (!xdomain) {
      try {
        return new window[(['Active'].concat('Object').join('X'))]('Microsoft.XMLHTTP');
      } catch(e) { }
    }

    return null;
  };

  /**
   * XHR based transport constructor.
   *
   * @constructor
   * @api public
   */

  /**
   * Change the internal pageLoaded value.
   */

  if ('undefined' != typeof window) {
    util.load(function () {
      pageLoaded = true;
    });
  }

  /**
   * Defers a function to ensure a spinner is not displayed by the browser
   *
   * @param {Function} fn
   * @api public
   */

  util.defer = function (fn) {
    if (!util.ua.webkit || 'undefined' != typeof importScripts) {
      return fn();
    }

    util.load(function () {
      setTimeout(fn, 100);
    });
  };

  /**
   * Merges two objects.
   *
   * @api public
   */

  util.merge = function merge (target, additional, deep, lastseen) {
    var seen = lastseen || []
      , depth = typeof deep == 'undefined' ? 2 : deep
      , prop;

    for (prop in additional) {
      if (additional.hasOwnProperty(prop) && util.indexOf(seen, prop) < 0) {
        if (typeof target[prop] !== 'object' || !depth) {
          target[prop] = additional[prop];
          seen.push(additional[prop]);
        } else {
          util.merge(target[prop], additional[prop], depth - 1, seen);
        }
      }
    }

    return target;
  };

  /**
   * Merges prototypes from objects
   *
   * @api public
   */

  util.mixin = function (ctor, ctor2) {
    util.merge(ctor.prototype, ctor2.prototype);
  };

  /**
   * Shortcut for prototypical and static inheritance.
   *
   * @api private
   */

  util.inherit = function (ctor, ctor2) {
    function f() {};
    f.prototype = ctor2.prototype;
    ctor.prototype = new f;
  };

  /**
   * Checks if the given object is an Array.
   *
   *     io.util.isArray([]); // true
   *     io.util.isArray({}); // false
   *
   * @param Object obj
   * @api public
   */

  util.isArray = Array.isArray || function (obj) {
    return Object.prototype.toString.call(obj) === '[object Array]';
  };

  /**
   * Intersects values of two arrays into a third
   *
   * @api public
   */

  util.intersect = function (arr, arr2) {
    var ret = []
      , longest = arr.length > arr2.length ? arr : arr2
      , shortest = arr.length > arr2.length ? arr2 : arr;

    for (var i = 0, l = shortest.length; i < l; i++) {
      if (~util.indexOf(longest, shortest[i]))
        ret.push(shortest[i]);
    }

    return ret;
  }

  /**
   * Array indexOf compatibility.
   *
   * @see bit.ly/a5Dxa2
   * @api public
   */

  util.indexOf = function (arr, o, i) {

    for (var j = arr.length, i = i < 0 ? i + j < 0 ? 0 : i + j : i || 0;
         i < j && arr[i] !== o; i++) {}

    return j <= i ? -1 : i;
  };

  /**
   * Converts enumerables to array.
   *
   * @api public
   */

  util.toArray = function (enu) {
    var arr = [];

    for (var i = 0, l = enu.length; i < l; i++)
      arr.push(enu[i]);

    return arr;
  };

  /**
   * UA / engines detection namespace.
   *
   * @namespace
   */

  util.ua = {};

  /**
   * Whether the UA supports CORS for XHR.
   *
   * @api public
   */

  util.ua.hasCORS = 'undefined' != typeof XMLHttpRequest && (function () {
    try {
      var a = new XMLHttpRequest();
    } catch (e) {
      return false;
    }

    return a.withCredentials != undefined;
  })();

  /**
   * Detect webkit.
   *
   * @api public
   */

  util.ua.webkit = 'undefined' != typeof navigator
    && /webkit/i.test(navigator.userAgent);

})(
    'undefined' != typeof io ? io : module.exports
  , 'undefined' === typeof global ? window : global);

/**
 * socket.io
 * Copyright(c) 2011 LearnBoost <dev@learnboost.com>
 * MIT Licensed
 */

(function (exports, io) {

  /**
   * Expose constructor.
   */

  exports.EventEmitter = EventEmitter;

  /**
   * Event emitter constructor.
   *
   * @api public.
   */

  function EventEmitter () {};

  /**
   * Adds a listener
   *
   * @api public
   */

  EventEmitter.prototype.on = function (name, fn) {
    if (!this.$events) {
      this.$events = {};
    }

    if (!this.$events[name]) {
      this.$events[name] = fn;
    } else if (io.util.isArray(this.$events[name])) {
      this.$events[name].push(fn);
    } else {
      this.$events[name] = [this.$events[name], fn];
    }

    return this;
  };

  EventEmitter.prototype.addListener = EventEmitter.prototype.on;

  /**
   * Adds a volatile listener.
   *
   * @api public
   */

  EventEmitter.prototype.once = function (name, fn) {
    var self = this;

    function on () {
      self.removeListener(name, on);
      fn.apply(this, arguments);
    };

    on.listener = fn;
    this.on(name, on);

    return this;
  };

  /**
   * Removes a listener.
   *
   * @api public
   */

  EventEmitter.prototype.removeListener = function (name, fn) {
    if (this.$events && this.$events[name]) {
      var list = this.$events[name];

      if (io.util.isArray(list)) {
        var pos = -1;

        for (var i = 0, l = list.length; i < l; i++) {
          if (list[i] === fn || (list[i].listener && list[i].listener === fn)) {
            pos = i;
            break;
          }
        }

        if (pos < 0) {
          return this;
        }

        list.splice(pos, 1);

        if (!list.length) {
          delete this.$events[name];
        }
      } else if (list === fn || (list.listener && list.listener === fn)) {
        delete this.$events[name];
      }
    }

    return this;
  };

  /**
   * Removes all listeners for an event.
   *
   * @api public
   */

  EventEmitter.prototype.removeAllListeners = function (name) {
    // TODO: enable this when node 0.5 is stable
    //if (name === undefined) {
      //this.$events = {};
      //return this;
    //}

    if (this.$events && this.$events[name]) {
      this.$events[name] = null;
    }

    return this;
  };

  /**
   * Gets all listeners for a certain event.
   *
   * @api publci
   */

  EventEmitter.prototype.listeners = function (name) {
    if (!this.$events) {
      this.$events = {};
    }

    if (!this.$events[name]) {
      this.$events[name] = [];
    }

    if (!io.util.isArray(this.$events[name])) {
      this.$events[name] = [this.$events[name]];
    }

    return this.$events[name];
  };

  /**
   * Emits an event.
   *
   * @api public
   */

  EventEmitter.prototype.emit = function (name) {
    if (!this.$events) {
      return false;
    }

    var handler = this.$events[name];

    if (!handler) {
      return false;
    }

    var args = Array.prototype.slice.call(arguments, 1);

    if ('function' == typeof handler) {
      handler.apply(this, args);
    } else if (io.util.isArray(handler)) {
      var listeners = handler.slice();

      for (var i = 0, l = listeners.length; i < l; i++) {
        listeners[i].apply(this, args);
      }
    } else {
      return false;
    }

    return true;
  };

})(
    'undefined' != typeof io ? io : module.exports
  , 'undefined' != typeof io ? io : module.parent.exports
);

/**
 * socket.io
 * Copyright(c) 2011 LearnBoost <dev@learnboost.com>
 * MIT Licensed
 */

/**
 * Removed JSON polyfill - obsolete, and we are using native JSON.parse etc. throughout the rest of the codebase anyway
 */

(function (exports, nativeJSON) {
  "use strict";

  // use native JSON if it's available
  if (nativeJSON && nativeJSON.parse){
    return exports.JSON = {
      parse: nativeJSON.parse
    , stringify: nativeJSON.stringify
    }
  }

  throw new Error("JSON not available");
  
})(
    'undefined' != typeof io ? io : module.exports
  , typeof JSON !== 'undefined' ? JSON : undefined
);

/**
 * socket.io
 * Copyright(c) 2011 LearnBoost <dev@learnboost.com>
 * MIT Licensed
 */

(function (exports, io) {

  /**
   * Parser namespace.
   *
   * @namespace
   */

  var parser = exports.parser = {};

  /**
   * Packet types.
   */

  var packets = parser.packets = [
      'disconnect'
    , 'connect'
    , 'heartbeat'
    , 'message'
    , 'json'
    , 'event'
    , 'ack'
    , 'error'
    , 'noop'
  ];

  /**
   * Errors reasons.
   */

  var reasons = parser.reasons = [
      'transport not supported'
    , 'client not handshaken'
    , 'unauthorized'
  ];

  /**
   * Errors advice.
   */

  var advice = parser.advice = [
      'reconnect'
  ];

  /**
   * Shortcuts.
   */

  var JSON = io.JSON
    , indexOf = io.util.indexOf;

  /**
   * Encodes a packet.
   *
   * @api private
   */

  parser.encodePacket = function (packet) {
    var type = indexOf(packets, packet.type)
      , id = packet.id || ''
      , endpoint = packet.endpoint || ''
      , ack = packet.ack
      , data = null;

    switch (packet.type) {
      case 'error':
        var reason = packet.reason ? indexOf(reasons, packet.reason) : ''
          , adv = packet.advice ? indexOf(advice, packet.advice) : '';

        if (reason !== '' || adv !== '')
          data = reason + (adv !== '' ? ('+' + adv) : '');

        break;

      case 'message':
        if (packet.data !== '')
          data = packet.data;
        break;

      case 'event':
        var ev = { name: packet.name };

        if (packet.args && packet.args.length) {
          ev.args = packet.args;
        }

        data = JSON.stringify(ev);
        break;

      case 'json':
        data = JSON.stringify(packet.data);
        break;

      case 'connect':
        if (packet.qs)
          data = packet.qs;
        break;

      case 'ack':
        data = packet.ackId
          + (packet.args && packet.args.length
              ? '+' + JSON.stringify(packet.args) : '');
        break;
    }

    // construct packet with required fragments
    var encoded = [
        type
      , id + (ack == 'data' ? '+' : '')
      , endpoint
    ];

    // data fragment is optional
    if (data !== null && data !== undefined)
      encoded.push(data);

    return encoded.join(':');
  };

  /**
   * Encodes multiple messages (payload).
   *
   * @param {Array} messages
   * @api private
   */

  parser.encodePayload = function (packets) {
    var decoded = '';

    if (packets.length == 1)
      return packets[0];

    for (var i = 0, l = packets.length; i < l; i++) {
      var packet = packets[i];
      decoded += '\ufffd' + packet.length + '\ufffd' + packets[i];
    }

    return decoded;
  };

  /**
   * Decodes a packet
   *
   * @api private
   */

  var regexp = /([^:]+):([0-9]+)?(\+)?:([^:]+)?:?([\s\S]*)?/;

  parser.decodePacket = function (data) {
    var pieces = data.match(regexp);

    if (!pieces) return {};

    var id = pieces[2] || ''
      , data = pieces[5] || ''
      , packet = {
            type: packets[pieces[1]]
          , endpoint: pieces[4] || ''
        };

    // whether we need to acknowledge the packet
    if (id) {
      packet.id = id;
      if (pieces[3])
        packet.ack = 'data';
      else
        packet.ack = true;
    }

    // handle different packet types
    switch (packet.type) {
      case 'error':
        var pieces = data.split('+');
        packet.reason = reasons[pieces[0]] || '';
        packet.advice = advice[pieces[1]] || '';
        break;

      case 'message':
        packet.data = data || '';
        break;

      case 'event':
        try {
          var opts = JSON.parse(data);
          packet.name = opts.name;
          packet.args = opts.args;
        } catch (e) { }

        packet.args = packet.args || [];
        break;

      case 'json':
        try {
          packet.data = JSON.parse(data);
        } catch (e) { }
        break;

      case 'connect':
        packet.qs = data || '';
        break;

      case 'ack':
        var pieces = data.match(/^([0-9]+)(\+)?(.*)/);
        if (pieces) {
          packet.ackId = pieces[1];
          packet.args = [];

          if (pieces[3]) {
            try {
              packet.args = pieces[3] ? JSON.parse(pieces[3]) : [];
            } catch (e) { }
          }
        }
        break;

      case 'disconnect':
        packet.reason = data;
        break;

      case 'heartbeat':
        break;
    };

    return packet;
  };

  /**
   * Decodes data payload. Detects multiple messages
   *
   * @return {Array} messages
   * @api public
   */

  parser.decodePayload = function (data) {
    // IE doesn't like data[i] for unicode chars, charAt works fine
    if (data.charAt(0) == '\ufffd') {
      var ret = [];

      for (var i = 1, length = ''; i < data.length; i++) {
        if (data.charAt(i) == '\ufffd') {
          ret.push(parser.decodePacket(data.substr(i + 1).substr(0, length)));
          i += Number(length) + 1;
          length = '';
        } else {
          length += data.charAt(i);
        }
      }

      return ret;
    } else {
      return [parser.decodePacket(data)];
    }
  };

})(
    'undefined' != typeof io ? io : module.exports
  , 'undefined' != typeof io ? io : module.parent.exports
);
/**
 * socket.io
 * Copyright(c) 2011 LearnBoost <dev@learnboost.com>
 * MIT Licensed
 */

(function (exports, io) {

  /**
   * Expose constructor.
   */

  exports.Transport = Transport;

  /**
   * This is the transport template for all supported transport methods.
   *
   * @constructor
   * @api public
   */

  function Transport (socket, sessid) {
    this.socket = socket;
    this.sessid = sessid;
    this.connectErrorCallback = undefined;
    this.isOpened = false;
  };

  /**
   * Apply EventEmitter mixin.
   */

  io.util.mixin(Transport, io.EventEmitter);

  /**
   * Handles the response from the server. When a new response is received
   * it will automatically update the timeout, decode the message and
   * forwards the response to the onMessage function for further processing.
   *
   * @param {String} data Response from the server.
   * @api private
   */

  Transport.prototype.onData = function (data) {
    this.clearCloseTimeout();

    // If the connection in currently open (or in a reopening state) reset the close
    // timeout since we have just received data. This check is necessary so
    // that we don't reset the timeout on an explicitly disconnected connection.
    if (this.socket.connected || this.socket.connecting || this.socket.reconnecting) {
      this.setCloseTimeout();
    }

    if (data !== '') {
      // todo: we should only do decodePayload for xhr transports
      var msgs = io.parser.decodePayload(data);

      if (msgs && msgs.length) {
        for (var i = 0, l = msgs.length; i < l; i++) {
          this.onPacket(msgs[i]);
        }
      }
    }

    return this;
  };

  /**
   * Handles packets.
   *
   * @api private
   */

  Transport.prototype.onPacket = function (packet) {
    this.socket.setHeartbeatTimeout();

    if (packet.type == 'heartbeat') {
      return this.onHeartbeat();
    }

    if (packet.type == 'connect' && packet.endpoint == '') {
      this.onConnect();
    }

    if (packet.type == 'error' && packet.advice == 'reconnect') {
      this.isOpened = false;
    }

    this.socket.onPacket(packet);

    return this;
  };

  /**
   * Sets close timeout
   *
   * @api private
   */

  Transport.prototype.setCloseTimeout = function () {
    if (!this.closeTimeout) {
      var self = this;

      this.closeTimeout = setTimeout(function () {
        self.onDisconnect();
      }, this.socket.closeTimeout);
    }
  };

  /**
   * Called when transport disconnects.
   *
   * @api private
   */

  Transport.prototype.onDisconnect = function () {
    if (this.close && this.isOpened) this.close();
    this.clearTimeouts();
    this.socket.onDisconnect();
    return this;
  };

  /**
   * Called when transport connects
   *
   * @api private
   */

  Transport.prototype.onConnect = function () {
    this.socket.onConnect();
    this.connectErrorCallback = undefined;
    return this;
  }

  /**
   * Clears close timeout
   *
   * @api private
   */

  Transport.prototype.clearCloseTimeout = function () {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
  };

  /**
   * Clear timeouts
   *
   * @api private
   */

  Transport.prototype.clearTimeouts = function () {
    this.clearCloseTimeout();

    if (this.reopenTimeout) {
      clearTimeout(this.reopenTimeout);
    }
  };

  /**
   * Sends a packet
   *
   * @param {Object} packet object.
   * @api private
   */

  Transport.prototype.packet = function (packet) {
    this.send(io.parser.encodePacket(packet));
  };

  /**
   * Send the received heartbeat message back to server. So the server
   * knows we are still connected.
   *
   * @param {String} heartbeat Heartbeat response from the server.
   * @api private
   */

  Transport.prototype.onHeartbeat = function (heartbeat) {
    this.packet({ type: 'heartbeat' });
  };

  /**
   * Called when the transport opens.
   *
   * @api private
   */

  Transport.prototype.onOpen = function () {
    this.isOpened = true;
    this.clearCloseTimeout();
    this.socket.onOpen();
  };

  /**
   * Notifies the base when the connection with the Socket.IO server
   * has been disconnected.
   *
   * @api private
   */

  Transport.prototype.onClose = function () {
    var self = this;

    /* FIXME: reopen delay causing a infinit loop
    this.reopenTimeout = setTimeout(function () {
      self.open();
    }, this.socket.options['reopen delay']);*/

    this.isOpened = false;
    this.socket.onClose();
    this.onDisconnect();
  };

  /**
   * Generates a connection url based on the Socket.IO URL Protocol.
   * See <https://github.com/learnboost/socket.io-node/> for more details.
   *
   * @returns {String} Connection url
   * @api private
   */

  Transport.prototype.prepareUrl = function () {
    var options = this.socket.options;

    return this.scheme() + '://'
      + options.host + ':' + options.port + '/'
      + options.resource + '/' + io.protocol
      + '/' + this.name + '/' + this.sessid;
  };

  /**
   * Checks if the transport is ready to start a connection.
   *
   * @param {Socket} socket The socket instance that needs a transport
   * @param {Function} fn The callback
   * @api private
   */

  Transport.prototype.ready = function (socket, fn) {
    fn.call(this);
  };

  /**
   * Clears the event handlers attached on to by specific transport implementations.
   *
   * @api private
   */
  Transport.prototype.clearEventHandlers = function () {
      return this;
  };
})(
    'undefined' != typeof io ? io : module.exports
  , 'undefined' != typeof io ? io : module.parent.exports
);
/**
 * socket.io
 * Copyright(c) 2011 LearnBoost <dev@learnboost.com>
 * MIT Licensed
 */

(function (exports, io, global) {

  /**
   * Expose constructor.
   */

  exports.Socket = Socket;

  /**
   * Create a new `Socket.IO client` which can establish a persistent
   * connection with a Socket.IO enabled server.
   *
   * @api public
   */

  function Socket (options) {
    this.options = {
        port: 80
      , secure: false
      , document: 'document' in global ? document : false
      , resource: 'socket.io'
      , transports: io.transports.slice()
      , 'connect timeout': 10000
      , 'try multiple transports': true
      , 'reconnect': true
      , 'reconnection delay': 500
      , 'reconnection limit': Infinity
      , 'reopen delay': 3000
      , 'max reconnection attempts': 10
      , 'sync disconnect on unload': true
      , 'auto connect': true
      , 'flash policy port': 10843
    };

    io.util.merge(this.options, options);

    this.connected = false;
    this.open = false;
    this.connecting = false;
    this.reconnecting = false;
    this.namespaces = {};
    this.buffer = [];
    this.doBuffer = false;
    this.disconnected = false;

    if (this.options['sync disconnect on unload'] &&
        (!this.isXDomain() || io.util.ua.hasCORS)) {
      var self = this;

      io.util.on(global, 'unload', function () {
        self.disconnectSync();
      }, false);
    }

    if (this.options['auto connect']) {
      this.connect();
    }
};

  /**
   * Apply EventEmitter mixin.
   */

  io.util.mixin(Socket, io.EventEmitter);

  /**
   * Returns a namespace listener/emitter for this socket
   *
   * @api public
   */

  Socket.prototype.of = function (name) {
    if (!this.namespaces[name]) {
      this.namespaces[name] = new io.SocketNamespace(this, name);

      if (name !== '') {
        this.namespaces[name].packet({ type: 'connect' });
      }
    }

    return this.namespaces[name];
  };

  /**
   * Emits the given event to the Socket and all namespaces
   *
   * @api private
   */

  Socket.prototype.publish = function () {
    this.emit.apply(this, arguments);

    var nsp;

    for (var i in this.namespaces) {
      if (this.namespaces.hasOwnProperty(i)) {
        nsp = this.of(i);
        nsp.$emit.apply(nsp, arguments);
      }
    }
  };

  /**
   * Performs the handshake
   *
   * @api private
   */

  function empty () { };

  Socket.prototype.handshake = function (fn) {
    var self = this
      , options = this.options;
      
    if (self.disconnected) {
      return;
    }

    function complete (data) {
      if (data instanceof Error) {
        self.onError(data.message);
      } else {
        fn.apply(null, data.split(':'));
      }
    };

    var url = [
          'http' + (options.secure ? 's' : '') + ':/'
        , options.host + ':' + options.port
        , options.resource
        , io.protocol
        , io.util.query(this.options.query, 't=' + +new Date)
      ].join('/');

    if (this.isXDomain() && !io.util.ua.hasCORS) {
      var insertAt = document.getElementsByTagName('script')[0]
        , script = document.createElement('script');

      script.src = url + '&jsonp=' + io.j.length;
      insertAt.parentNode.insertBefore(script, insertAt);

      io.j.push(function (data) {
        complete(data);
        script.parentNode.removeChild(script);
      });
    } else {
      var xhr = io.util.request();
      
      xhr.open('GET', url, true);
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          xhr.onreadystatechange = empty;

          if (xhr.status == 200) {
            complete(xhr.responseText);
          } else {
            !self.reconnecting && self.onError(xhr.responseText);
          }
        }
      };
      xhr.send(null);
    }
  };

  /**
   * Find an available transport based on the options supplied in the constructor.
   *
   * @api private
   */

  Socket.prototype.getTransport = function (override) {
    var transports = override || this.transports, match;

    for (var i = 0, transport; transport = transports[i]; i++) {
      if (io.Transport[transport]
        && io.Transport[transport].check(this)
        && (!this.isXDomain() || io.Transport[transport].xdomainCheck())) {
        return new io.Transport[transport](this, this.sessionid);
      }
    }

    return null;
  };

  /**
   * Connects to the server.
   *
   * @param {Function} [fn] Callback.
   * @returns {io.Socket}
   * @api public
   */

  Socket.prototype.connect = function (fn) {
    if (this.connecting || this.disconnected) {
      return this;
    }

    var self = this;

    this.handshake(function (sid, heartbeat, close, transports) {
      // Params come from response's body - it's splitted by ':'
      // example: 1178beba4026e2c7-48e62d038b18f416:85:85:websocket,xhr-polling,jsonp-polling
      self.sessionid = sid;
      // Add two seconds, so connection is closed by server, not client - otherwise
      // there will be a onSocketDisconnect event which will start health check, etc
      // This can happen if server returns close/heartbeat timeout equal to 40 which is server's timeout to
      // close long poll connection, in such case client can close connection before server response with empty
      // response and client goes to health check. Server can return such timeout if client send too small ping timeout
      // during handshake
      self.closeTimeout = close * 1000 + 2000;
      self.heartbeatTimeout = heartbeat * 1000 + 2000;
      self.transports = transports ? io.util.intersect(
          transports.split(',')
        , self.options.transports
      ) : self.options.transports;

      self.setHeartbeatTimeout();
      self.remainingTransports = self.transports.slice(0);

      function tryNextTransport() {
        if (!self.connected && !self.disconnected) {
          self.connecting = false;
          clearTimeout(self.connectTimeoutTimer);

          if (self.options['try multiple transports']) {
            while (self.remainingTransports.length > 0
                   && self.remainingTransports.splice(0,1)[0] != self.transport.name) {}

            if (self.remainingTransports.length){
              connect(self.remainingTransports);
            } else {
              self.publish('connect_failed');
            }
          } else {
            self.publish('connect_failed');
          }
        }
      }


      function connect (transports){
        if (self.transport) {
            self.transport.clearTimeouts();
            self.transport.clearEventHandlers();
        }

        self.transport = self.getTransport(transports);
        if (!self.transport || self.disconnected) return self.publish('connect_failed');

        // once the transport is ready (i.e. page is fully loaded)
        self.transport.ready(self, function () {
          self.connecting = true;
          self.publish('connecting', self.transport.name);
          self.transport.open(tryNextTransport);

          if (self.options['connect timeout']) {
            self.connectTimeoutTimer = setTimeout(function () {
              tryNextTransport();
            }, self.options['connect timeout']);
          }
        });
      }

      connect(self.transports);

      self.once('connect', function (){
        clearTimeout(self.connectTimeoutTimer);

        fn && typeof fn == 'function' && fn();
      });
    });

    return this;
  };

  /**
   * Clears and sets a new heartbeat timeout using the value given by the
   * server during the handshake.
   *
   * @api private
   */

  Socket.prototype.setHeartbeatTimeout = function () {
    clearTimeout(this.heartbeatTimeoutTimer);

    var self = this;
    this.heartbeatTimeoutTimer = setTimeout(function () {
      self.transport.onClose();
    }, this.heartbeatTimeout);
  };

  /**
   * Sends a message.
   *
   * @param {Object} data packet.
   * @returns {io.Socket}
   * @api public
   */

  Socket.prototype.packet = function (data) {
    if (this.connected && !this.doBuffer) {
      this.transport.packet(data);
    } else {
      this.buffer.push(data);
    }

    return this;
  };

  /**
   * Sets buffer state
   *
   * @api private
   */

  Socket.prototype.setBuffer = function (v) {
    this.doBuffer = v;

    if (!v && this.connected && this.buffer.length) {
      this.transport.payload(this.buffer);
      this.buffer = [];
    }
  };

  /**
   * Disconnect the established connect.
   *
   * @returns {io.Socket}
   * @api public
   */

  Socket.prototype.disconnect = function () {
    if (this.connected || this.connecting) {
      if (this.open) {
        this.of('').packet({ type: 'disconnect' });
      }

      // handle disconnection immediately
      this.onDisconnect('booted');
    }
    this.disconnected = true;

    return this;
  };

  /**
   * Disconnects the socket with a sync XHR.
   *
   * @api private
   */

  Socket.prototype.disconnectSync = function () {
    // ensure disconnection
    var xhr = io.util.request()
      , uri = this.resource + '/' + io.protocol + '/' + this.sessionid;

    xhr.open('GET', uri, true);

    // handle disconnection immediately
    this.onDisconnect('booted');
  };

  /**
   * Check if we need to use cross domain enabled transports. Cross domain would
   * be a different port or different domain name.
   *
   * @returns {Boolean}
   * @api private
   */

  Socket.prototype.isXDomain = function () {

    var port = global.location.port ||
      ('https:' == global.location.protocol ? 443 : 80);

    return this.options.host !== global.location.hostname
      || this.options.port != port;
  };

  /**
   * Called upon handshake.
   *
   * @api private
   */

  Socket.prototype.onConnect = function () {
    if (!this.connected) {
      this.connected = true;
      this.connecting = false;
      if (!this.doBuffer) {
        // make sure to flush the buffer
        this.setBuffer(false);
      }
      this.emit('connect');
    }
  };

  /**
   * Called when the transport opens
   *
   * @api private
   */

  Socket.prototype.onOpen = function () {
    this.open = true;
  };

  /**
   * Called when the transport closes.
   *
   * @api private
   */

  Socket.prototype.onClose = function () {
    this.open = false;
    clearTimeout(this.heartbeatTimeoutTimer);
  };

  /**
   * Called when the transport first opens a connection
   *
   * @param text
   */

  Socket.prototype.onPacket = function (packet) {
    this.of(packet.endpoint).onPacket(packet);
  };

  /**
   * Handles an error.
   *
   * @api private
   */

  Socket.prototype.onError = function (err) {
    if (err && err.advice) {
      if (err.advice === 'reconnect' && (this.connected || this.connecting)) {
        this.disconnect();
        if (this.options.reconnect) {
          this.reconnect();
        }
      }
    }

    this.publish('error', err && err.reason ? err.reason : err);
  };

  /**
   * Called when the transport disconnects.
   *
   * @api private
   */

  Socket.prototype.onDisconnect = function (reason) {
    var wasConnected = this.connected
      , wasConnecting = this.connecting;

    this.connected = false;
    this.connecting = false;
    this.open = false;

    if (wasConnected || wasConnecting) {
      this.transport.close();
      this.transport.clearTimeouts();
      if (wasConnected) {
        this.publish('disconnect', reason);

        if ('booted' != reason && this.options.reconnect && !this.reconnecting) {
          this.reconnect();
        }
      }
    }
  };

  /**
   * Called upon reconnection.
   *
   * @api private
   */

  Socket.prototype.reconnect = function () {
    this.reconnecting = true;
    this.reconnectionAttempts = 0;
    this.reconnectionDelay = this.options['reconnection delay'];

    var self = this
      , maxAttempts = this.options['max reconnection attempts']
      , tryMultiple = this.options['try multiple transports']
      , limit = this.options['reconnection limit'];

    function reset () {
      if (self.connected) {
        for (var i in self.namespaces) {
          if (self.namespaces.hasOwnProperty(i) && '' !== i) {
              self.namespaces[i].packet({ type: 'connect' });
          }
        }
        self.publish('reconnect', self.transport.name, self.reconnectionAttempts);
      }

      clearTimeout(self.reconnectionTimer);

      self.removeListener('connect_failed', maybeReconnect);
      self.removeListener('connect', maybeReconnect);

      self.reconnecting = false;

      delete self.reconnectionAttempts;
      delete self.reconnectionDelay;
      delete self.reconnectionTimer;
      delete self.redoTransports;

      self.options['try multiple transports'] = tryMultiple;
    };

    function maybeReconnect () {
      if (!self.reconnecting) {
        return;
      }

      if (self.connected) {
        return reset();
      };

      if (self.connecting && self.reconnecting) {
        return self.reconnectionTimer = setTimeout(maybeReconnect, 1000);
      }

      if (self.reconnectionAttempts++ >= maxAttempts) {
        if (!self.redoTransports) {
          self.on('connect_failed', maybeReconnect);
          self.options['try multiple transports'] = true;
          self.transport = self.getTransport();
          self.redoTransports = true;
          self.connect();
        } else {
          self.publish('reconnect_failed');
          reset();
        }
      } else {
        if (self.reconnectionDelay < limit) {
          self.reconnectionDelay *= 2; // exponential back off
        }

        self.connect();
        self.publish('reconnecting', self.reconnectionDelay, self.reconnectionAttempts);
        self.reconnectionTimer = setTimeout(maybeReconnect, self.reconnectionDelay);
      }
    };

    this.options['try multiple transports'] = false;
    this.reconnectionTimer = setTimeout(maybeReconnect, this.reconnectionDelay);

    this.on('connect', maybeReconnect);
  };

})(
    'undefined' != typeof io ? io : module.exports
  , 'undefined' != typeof io ? io : module.parent.exports
  , 'undefined' === typeof global ? window : global
);
/**
 * socket.io
 * Copyright(c) 2011 LearnBoost <dev@learnboost.com>
 * MIT Licensed
 */

(function (exports, io) {

  /**
   * Expose constructor.
   */

  exports.SocketNamespace = SocketNamespace;

  /**
   * Socket namespace constructor.
   *
   * @constructor
   * @api public
   */

  function SocketNamespace (socket, name) {
    this.socket = socket;
    this.name = name || '';
    this.flags = {};
    this.json = new Flag(this, 'json');
    this.ackPackets = 0;
    this.acks = {};
  };

  /**
   * Apply EventEmitter mixin.
   */

  io.util.mixin(SocketNamespace, io.EventEmitter);

  /**
   * Copies emit since we override it
   *
   * @api private
   */

  SocketNamespace.prototype.$emit = io.EventEmitter.prototype.emit;

  /**
   * Creates a new namespace, by proxying the request to the socket. This
   * allows us to use the synax as we do on the server.
   *
   * @api public
   */

  SocketNamespace.prototype.of = function () {
    return this.socket.of.apply(this.socket, arguments);
  };

  /**
   * Sends a packet.
   *
   * @api private
   */

  SocketNamespace.prototype.packet = function (packet) {
    packet.endpoint = this.name;
    this.socket.packet(packet);
    this.flags = {};
    return this;
  };

  /**
   * Sends a message
   *
   * @api public
   */

  SocketNamespace.prototype.send = function (data, fn) {
    var packet = {
        type: this.flags.json ? 'json' : 'message'
      , data: data
    };

    if ('function' == typeof fn) {
      packet.id = ++this.ackPackets;
      packet.ack = true;
      this.acks[packet.id] = fn;
    }

    return this.packet(packet);
  };

  /**
   * Emits an event
   *
   * @api public
   */

  SocketNamespace.prototype.emit = function (name) {
    var args = Array.prototype.slice.call(arguments, 1)
      , lastArg = args[args.length - 1]
      , packet = {
            type: 'event'
          , name: name
        };

    if ('function' == typeof lastArg) {
      packet.id = ++this.ackPackets;
      packet.ack = 'data';
      this.acks[packet.id] = lastArg;
      args = args.slice(0, args.length - 1);
    }

    packet.args = args;

    return this.packet(packet);
  };

  /**
   * Disconnects the namespace
   *
   * @api private
   */

  SocketNamespace.prototype.disconnect = function () {
    if (this.name === '') {
      this.socket.disconnect();
    } else {
      this.packet({ type: 'disconnect' });
      this.$emit('disconnect');
    }

    return this;
  };

  /**
   * Handles a packet
   *
   * @api private
   */

  SocketNamespace.prototype.onPacket = function (packet) {
    var self = this;

    function ack () {
      self.packet({
          type: 'ack'
        , args: io.util.toArray(arguments)
        , ackId: packet.id
      });
    };

    switch (packet.type) {
      case 'connect':
        this.$emit('connect');
        break;

      case 'disconnect':
        if (this.name === '') {
          this.socket.onDisconnect(packet.reason || 'booted');
        } else {
          this.$emit('disconnect', packet.reason || '');
        }
        break;

      case 'message':
      case 'json':
        var params = ['message', packet.data];

        if (packet.ack == 'data') {
          params.push(ack);
        } else if (packet.ack) {
          this.packet({ type: 'ack', ackId: packet.id });
        }

        this.$emit.apply(this, params);
        break;

      case 'event':
        var params = [packet.name].concat(packet.args);

        if (packet.ack == 'data')
          params.push(ack);

        this.$emit.apply(this, params);
        break;

      case 'ack':
        if (this.acks[packet.ackId]) {
          this.acks[packet.ackId].apply(this, packet.args);
          delete this.acks[packet.ackId];
        }
        break;

      case 'error':
        if (packet.advice){
          this.socket.onError(packet);
        } else {
          if (packet.reason == 'unauthorized') {
            this.$emit('connect_failed', packet.reason);
          } else {
            this.$emit('error', packet.reason);
          }
        }
        break;
    }
  };

  /**
   * Flag interface.
   *
   * @api private
   */

  function Flag (nsp, name) {
    this.namespace = nsp;
    this.name = name;
  };

  /**
   * Send a message
   *
   * @api public
   */

  Flag.prototype.send = function () {
    this.namespace.flags[this.name] = true;
    this.namespace.send.apply(this.namespace, arguments);
  };

  /**
   * Emit an event
   *
   * @api public
   */

  Flag.prototype.emit = function () {
    this.namespace.flags[this.name] = true;
    this.namespace.emit.apply(this.namespace, arguments);
  };

})(
    'undefined' != typeof io ? io : module.exports
  , 'undefined' != typeof io ? io : module.parent.exports
);

/**
 * socket.io
 * Copyright(c) 2011 LearnBoost <dev@learnboost.com>
 * MIT Licensed
 */

(function (exports, io, global) {

  /**
   * Expose constructor.
   */

  exports.websocket = WS;

  /**
   * The WebSocket transport uses the HTML5 WebSocket API to establish an
   * persistent connection with the Socket.IO server. This transport will also
   * be inherited by the FlashSocket fallback as it provides a API compatible
   * polyfill for the WebSockets.
   *
   * @constructor
   * @extends {io.Transport}
   * @api public
   */

  function WS (socket) {
    io.Transport.apply(this, arguments);
  };

  /**
   * Inherits from Transport.
   */

  io.util.inherit(WS, io.Transport);

  /**
   * Transport name
   *
   * @api public
   */

  WS.prototype.name = 'websocket';

  function empty() { };

  /**
   * Initializes a new `WebSocket` connection with the Socket.IO server. We attach
   * all the appropriate listeners to handle the responses from the server.
   *
   * @returns {Transport}
   * @api public
   */

  WS.prototype.open = function (connectErrorCallback) {
    var query = io.util.query(this.socket.options.query)
      , self = this
      , Socket

    this.connectErrorCallback = connectErrorCallback;

    if (!Socket) {
      Socket = global.MozWebSocket || global.WebSocket;
    }

    this.websocket = new Socket(this.prepareUrl() + query);

    this.websocket.onopen = function () {
      self.onOpen();
      self.socket.setBuffer(false);
    };
    this.websocket.onmessage = function (ev) {
      self.onData(ev.data);
    };
    this.websocket.onclose = function () {
      self.onClose();
      self.socket.setBuffer(true);
    };
    this.websocket.onerror = function (e) {
      self.onError(e);
    };

    return this;
  };

  /**
   * Send a message to the Socket.IO server. The message will automatically be
   * encoded in the correct message format.
   *
   * @returns {Transport}
   * @api public
   */

  WS.prototype.send = function (data) {
    this.websocket.send(data);
    return this;
  };

  /**
   * Payload
   *
   * @api private
   */

  WS.prototype.payload = function (arr) {
    for (var i = 0, l = arr.length; i < l; i++) {
      this.packet(arr[i]);
    }
    return this;
  };

  /**
   * Disconnect the established `WebSocket` connection.
   *
   * @returns {Transport}
   * @api public
   */

  WS.prototype.close = function () {
    this.websocket.close();
    return this;
  };

  /**
   * Handle the errors that `WebSocket` might be giving when we
   * are attempting to connect or send messages.
   *
   * @param {Error} e The error.
   * @api private
   */

  WS.prototype.onError = function (e) {
      if (this.connectErrorCallback !== undefined) {
        this.connectErrorCallback();
        this.connectErrorCallback = undefined;
      }
      this.socket.onError(e);
  };

  /**
   * Returns the appropriate scheme for the URI generation.
   *
   * @api private
   */
  WS.prototype.scheme = function () {
    return this.socket.options.secure ? 'wss' : 'ws';
  };

  /**
   * Checks if the browser has support for native `WebSockets` and that
   * it's not the polyfill created for the FlashSocket transport.
   *
   * @return {Boolean}
   * @api public
   */

  WS.check = function () {
    return ('WebSocket' in global && !('__addTask' in WebSocket))
          || 'MozWebSocket' in global;
  };

  /**
   * Check if the `WebSocket` transport support cross domain communications.
   *
   * @returns {Boolean}
   * @api public
   */

  WS.xdomainCheck = function () {
    return true;
  };

  /**
   * Clears the event listeners attached to the `WebSocket` transport object.
   *
   * @api private
   */
  WS.prototype.clearEventHandlers = function() {
      if (this.websocket) {
          this.websocket.onopen = this.websocket.onmessage = this.websocket.onclose = this.websocket.onerror = empty;
      }
      return this;
  };

  /**
   * Add the transport to your public io.transports array.
   *
   * @api private
   */

  io.transports.push('websocket');

})(
    'undefined' != typeof io ? io.Transport : module.exports
  , 'undefined' != typeof io ? io : module.parent.exports
  , 'undefined' === typeof global ? window : global
);

/**
 * socket.io
 * Copyright(c) 2011 LearnBoost <dev@learnboost.com>
 * MIT Licensed
 */

(function (exports, io, global) {

  /**
   * Expose constructor.
   *
   * @api public
   */

  exports.XHR = XHR;

  /**
   * XHR constructor
   *
   * @costructor
   * @api public
   */

  function XHR (socket) {
    if (!socket) return;

    io.Transport.apply(this, arguments);
    this.sendBuffer = [];
  };

  /**
   * Inherits from Transport.
   */

  io.util.inherit(XHR, io.Transport);

  /**
   * Establish a connection
   *
   * @returns {Transport}
   * @api public
   */

  XHR.prototype.open = function () {
    this.socket.setBuffer(false);
    this.onOpen();
    this.get();

    // we need to make sure the request succeeds since we have no indication
    // whether the request opened or not until it succeeded.
    this.setCloseTimeout();

    return this;
  };

  /**
   * Check if we need to send data to the Socket.IO server, if we have data in our
   * buffer we encode it and forward it to the `post` method.
   *
   * @api private
   */

  XHR.prototype.payload = function (payload) {
    var msgs = [];

    for (var i = 0, l = payload.length; i < l; i++) {
      msgs.push(io.parser.encodePacket(payload[i]));
    }

    this.send(io.parser.encodePayload(msgs));
  };

  /**
   * Send data to the Socket.IO server.
   *
   * @param data The message
   * @returns {Transport}
   * @api public
   */

  XHR.prototype.send = function (data) {
    this.post(data);
    return this;
  };

  /**
   * Posts a encoded message to the Socket.IO server.
   *
   * @param {String} data A encoded message.
   * @api private
   */

  function empty () { };

  XHR.prototype.post = function (data) {
    var self = this;
    this.socket.setBuffer(true);

    this.sendXHR = this.request('POST');

    function stateChange () {
      if (this.readyState == 4) {
        this.onreadystatechange = empty;
        self.posting = false;

        if (this.status == 200){
          self.socket.setBuffer(false);
          clearTimeout(self.sendXHR.ackTimeoutTimer);
        } else {
          self.onClose();
        }
      }
    }

    function onload () {
      this.onload = empty;
      self.socket.setBuffer(false);
    };

    if (global.XDomainRequest && this.sendXHR instanceof XDomainRequest) {
      this.sendXHR.onload = this.sendXHR.onerror = onload;
    } else {
      this.sendXHR.onreadystatechange = stateChange;
    }

    this.sendXHR.send(data);
    self.sendXHR.ackTimeoutTimer = setTimeout(function () {
      self.onClose();
    }, self.socket.options.ackTimeoutMs);
  };

  /**
   * Disconnects the established `XHR` connection.
   *
   * @returns {Transport}
   * @api public
   */

  XHR.prototype.close = function () {
    this.onClose();
    return this;
  };

  /**
   * Generates a configured XHR request
   *
   * @param {String} url The url that needs to be requested.
   * @param {String} method The method the request should use.
   * @returns {XMLHttpRequest}
   * @api private
   */

  XHR.prototype.request = function (method) {
    var req = io.util.request(this.socket.isXDomain())
      , query = io.util.query(this.socket.options.query, 't=' + +new Date);

    req.open(method || 'GET', this.prepareUrl() + query, true);

    if (method == 'POST') {
      try {
        if (req.setRequestHeader) {
          req.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
        } else {
          // XDomainRequest
          req.contentType = 'text/plain';
        }
      } catch (e) {}
    }

    return req;
  };

  /**
   * Returns the scheme to use for the transport URLs.
   *
   * @api private
   */

  XHR.prototype.scheme = function () {
    return this.socket.options.secure ? 'https' : 'http';
  };

  /**
   * Check if the XHR transports are supported
   *
   * @param {Boolean} xdomain Check if we support cross domain requests.
   * @returns {Boolean}
   * @api public
   */

  XHR.check = function (socket, xdomain) {

    try {
      var request = io.util.request(xdomain),
          usesXDomReq = (global.XDomainRequest && request instanceof XDomainRequest),
          socketProtocol = (socket && socket.options && socket.options.secure ? 'https:' : 'http:'),
          isXProtocol = (socketProtocol != global.location.protocol);
      if (request && !(usesXDomReq && isXProtocol)) {
        return true;
      }
    } catch(e) {}

    return false;
  };

  /**
   * Check if the XHR transport supports cross domain requests.
   *
   * @returns {Boolean}
   * @api public
   */

  XHR.xdomainCheck = function () {
    return XHR.check(null, true);
  };

  /**
   * Clears the event listeners attached to the XHR transport object.
   *
   * @api private
   */
  XHR.prototype.clearEventHandlers = function () {
      if (this.sendXHR) {
          this.sendXHR.onreadystatechange = this.sendXHR.onload = empty;
      }
      return this;
  };

})(
    'undefined' != typeof io ? io.Transport : module.exports
  , 'undefined' != typeof io ? io : module.parent.exports
  , 'undefined' === typeof global ? window : global
);

/**
 * socket.io
 * Copyright(c) 2011 LearnBoost <dev@learnboost.com>
 * MIT Licensed
 */

(function (exports, io, global) {

  /**
   * Expose constructor.
   */

  exports['xhr-polling'] = XHRPolling;

  /**
   * The XHR-polling transport uses long polling XHR requests to create a
   * "persistent" connection with the server.
   *
   * @constructor
   * @api public
   */

  function XHRPolling () {
    io.Transport.XHR.apply(this, arguments);
  };

  /**
   * Inherits from XHR transport.
   */

  io.util.inherit(XHRPolling, io.Transport.XHR);

  /**
   * Merge the properties from XHR transport
   */

  io.util.merge(XHRPolling, io.Transport.XHR);

  /**
   * Transport name
   *
   * @api public
   */

  XHRPolling.prototype.name = 'xhr-polling';

  /**
   * Establish a connection, for iPhone and Android this will be done once the page
   * is loaded.
   *
   * @returns {Transport} Chaining.
   * @api public
   */

  XHRPolling.prototype.open = function (connectErrorCallback) {
    var self = this;

    self.connectErrorCallback = connectErrorCallback;

    io.Transport.XHR.prototype.open.call(self);
    return false;
  };

  /**
   * Starts a XHR request to wait for incoming messages.
   *
   * @api private
   */

  function empty () {};

  XHRPolling.prototype.get = function () {
    if (!this.isOpened) return;

    var self = this;

    function stateChange () {
      if (this.readyState == 4) {
        this.onreadystatechange = empty;

        if (this.status == 200) {
          self.connectErrorCallback = undefined;
          self.onData(this.responseText);
          self.get();
        } else {
          self.onClose();

          if (self.connectErrorCallback !== undefined) {
            self.connectErrorCallback();
            self.connectErrorCallback = undefined;
          }
        }
      }
    };

    function onload () {
      self.connectErrorCallback = undefined;
      this.onload = empty;
      this.onerror = empty;
      self.onData(this.responseText);
      self.get();
    };

    function onerror () {
      self.onClose();

      if (self.connectErrorCallback !== undefined) {
        self.connectErrorCallback();
        self.connectErrorCallback = undefined;
      }
    };

    this.xhr = this.request();

    if (global.XDomainRequest && this.xhr instanceof XDomainRequest) {
      this.xhr.onload = onload;
      this.xhr.onerror = onerror;
    } else {
      this.xhr.onreadystatechange = stateChange;
    }

    this.xhr.send(null);
  };

  /**
   * Handle the unclean close behavior.
   *
   * @api private
   */

  XHRPolling.prototype.onClose = function () {
    io.Transport.XHR.prototype.onClose.call(this);

    if (this.xhr) {
      this.xhr.onreadystatechange = this.xhr.onload = this.xhr.onerror = empty;
      try {
        this.xhr.abort();
      } catch(e){}
      this.xhr = null;
    }
  };

  /**
   * Webkit based browsers show a infinit spinner when you start a XHR request
   * before the browsers onload event is called so we need to defer opening of
   * the transport until the onload event is called. Wrapping the cb in our
   * defer method solve this.
   *
   * @param {Socket} socket The socket instance that needs a transport
   * @param {Function} fn The callback
   * @api private
   */

  XHRPolling.prototype.ready = function (socket, fn) {
    var self = this;

    io.util.defer(function () {
      fn.call(self);
    });
  };

   /**
   * Clears the event listeners attached to the XHR transport object.
   *
   * @api private
   */
  XHRPolling.prototype.clearEventHandlers = function () {
      io.Transport.XHR.prototype.clearEventHandlers.call(this);

      if (this.xhr) {
          this.xhr.onreadystatechange = this.xhr.onload = this.xhr.onerror = empty;
      }
      return this;
  }

  /**
   * Add the transport to your public io.transports array.
   *
   * @api private
   */

  io.transports.push('xhr-polling');

})(
    'undefined' != typeof io ? io.Transport : module.exports
  , 'undefined' != typeof io ? io : module.parent.exports
  , 'undefined' === typeof global ? window : global
);

exports.io = io;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(14)(module)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {var require;/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   4.0.5
 */

(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  return typeof x === 'function' || typeof x === 'object' && x !== null;
}

function isFunction(x) {
  return typeof x === 'function';
}

var _isArray = undefined;
if (!Array.isArray) {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
} else {
  _isArray = Array.isArray;
}

var isArray = _isArray;

var len = 0;
var vertxNext = undefined;
var customSchedulerFn = undefined;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var r = require;
    var vertx = __webpack_require__(21);
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = undefined;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var _arguments = arguments;

  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;

  if (_state) {
    (function () {
      var callback = _arguments[_state - 1];
      asap(function () {
        return invokeCallback(_state, child, callback, parent._result);
      });
    })();
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  _resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(16);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var GET_THEN_ERROR = new ErrorObject();

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    GET_THEN_ERROR.error = error;
    return GET_THEN_ERROR;
  }
}

function tryThen(then, value, fulfillmentHandler, rejectionHandler) {
  try {
    then.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        _resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      _reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      _reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    _reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return _resolve(promise, value);
    }, function (reason) {
      return _reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$) {
  if (maybeThenable.constructor === promise.constructor && then$$ === then && maybeThenable.constructor.resolve === resolve) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$ === GET_THEN_ERROR) {
      _reject(promise, GET_THEN_ERROR.error);
    } else if (then$$ === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$)) {
      handleForeignThenable(promise, maybeThenable, then$$);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function _resolve(promise, value) {
  if (promise === value) {
    _reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function _reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;

  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = undefined,
      callback = undefined,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function ErrorObject() {
  this.error = null;
}

var TRY_CATCH_ERROR = new ErrorObject();

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = undefined,
      error = undefined,
      succeeded = undefined,
      failed = undefined;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      _reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
      _resolve(promise, value);
    } else if (failed) {
      _reject(promise, error);
    } else if (settled === FULFILLED) {
      fulfill(promise, value);
    } else if (settled === REJECTED) {
      _reject(promise, value);
    }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      _resolve(promise, value);
    }, function rejectPromise(reason) {
      _reject(promise, reason);
    });
  } catch (e) {
    _reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function Enumerator(Constructor, input) {
  this._instanceConstructor = Constructor;
  this.promise = new Constructor(noop);

  if (!this.promise[PROMISE_ID]) {
    makePromise(this.promise);
  }

  if (isArray(input)) {
    this._input = input;
    this.length = input.length;
    this._remaining = input.length;

    this._result = new Array(this.length);

    if (this.length === 0) {
      fulfill(this.promise, this._result);
    } else {
      this.length = this.length || 0;
      this._enumerate();
      if (this._remaining === 0) {
        fulfill(this.promise, this._result);
      }
    }
  } else {
    _reject(this.promise, validationError());
  }
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
};

Enumerator.prototype._enumerate = function () {
  var length = this.length;
  var _input = this._input;

  for (var i = 0; this._state === PENDING && i < length; i++) {
    this._eachEntry(_input[i], i);
  }
};

Enumerator.prototype._eachEntry = function (entry, i) {
  var c = this._instanceConstructor;
  var resolve$$ = c.resolve;

  if (resolve$$ === resolve) {
    var _then = getThen(entry);

    if (_then === then && entry._state !== PENDING) {
      this._settledAt(entry._state, i, entry._result);
    } else if (typeof _then !== 'function') {
      this._remaining--;
      this._result[i] = entry;
    } else if (c === Promise) {
      var promise = new c(noop);
      handleMaybeThenable(promise, entry, _then);
      this._willSettleAt(promise, i);
    } else {
      this._willSettleAt(new c(function (resolve$$) {
        return resolve$$(entry);
      }), i);
    }
  } else {
    this._willSettleAt(resolve$$(entry), i);
  }
};

Enumerator.prototype._settledAt = function (state, i, value) {
  var promise = this.promise;

  if (promise._state === PENDING) {
    this._remaining--;

    if (state === REJECTED) {
      _reject(promise, value);
    } else {
      this._result[i] = value;
    }
  }

  if (this._remaining === 0) {
    fulfill(promise, this._result);
  }
};

Enumerator.prototype._willSettleAt = function (promise, i) {
  var enumerator = this;

  subscribe(promise, undefined, function (value) {
    return enumerator._settledAt(FULFILLED, i, value);
  }, function (reason) {
    return enumerator._settledAt(REJECTED, i, reason);
  });
};

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  _reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {function} resolver
  Useful for tooling.
  @constructor
*/
function Promise(resolver) {
  this[PROMISE_ID] = nextId();
  this._result = this._state = undefined;
  this._subscribers = [];

  if (noop !== resolver) {
    typeof resolver !== 'function' && needsResolver();
    this instanceof Promise ? initializePromise(this, resolver) : needsNew();
  }
}

Promise.all = all;
Promise.race = race;
Promise.resolve = resolve;
Promise.reject = reject;
Promise._setScheduler = setScheduler;
Promise._setAsap = setAsap;
Promise._asap = asap;

Promise.prototype = {
  constructor: Promise,

  /**
    The primary way of interacting with a promise is through its `then` method,
    which registers callbacks to receive either a promise's eventual value or the
    reason why the promise cannot be fulfilled.
  
    ```js
    findUser().then(function(user){
      // user is available
    }, function(reason){
      // user is unavailable, and you are given the reason why
    });
    ```
  
    Chaining
    --------
  
    The return value of `then` is itself a promise.  This second, 'downstream'
    promise is resolved with the return value of the first promise's fulfillment
    or rejection handler, or rejected if the handler throws an exception.
  
    ```js
    findUser().then(function (user) {
      return user.name;
    }, function (reason) {
      return 'default name';
    }).then(function (userName) {
      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
      // will be `'default name'`
    });
  
    findUser().then(function (user) {
      throw new Error('Found user, but still unhappy');
    }, function (reason) {
      throw new Error('`findUser` rejected and we're unhappy');
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
    });
    ```
    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
  
    ```js
    findUser().then(function (user) {
      throw new PedagogicalException('Upstream error');
    }).then(function (value) {
      // never reached
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // The `PedgagocialException` is propagated all the way down to here
    });
    ```
  
    Assimilation
    ------------
  
    Sometimes the value you want to propagate to a downstream promise can only be
    retrieved asynchronously. This can be achieved by returning a promise in the
    fulfillment or rejection handler. The downstream promise will then be pending
    until the returned promise is settled. This is called *assimilation*.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // The user's comments are now available
    });
    ```
  
    If the assimliated promise rejects, then the downstream promise will also reject.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // If `findCommentsByAuthor` fulfills, we'll have the value here
    }, function (reason) {
      // If `findCommentsByAuthor` rejects, we'll have the reason here
    });
    ```
  
    Simple Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let result;
  
    try {
      result = findResult();
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
    findResult(function(result, err){
      if (err) {
        // failure
      } else {
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findResult().then(function(result){
      // success
    }, function(reason){
      // failure
    });
    ```
  
    Advanced Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let author, books;
  
    try {
      author = findAuthor();
      books  = findBooksByAuthor(author);
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
  
    function foundBooks(books) {
  
    }
  
    function failure(reason) {
  
    }
  
    findAuthor(function(author, err){
      if (err) {
        failure(err);
        // failure
      } else {
        try {
          findBoooksByAuthor(author, function(books, err) {
            if (err) {
              failure(err);
            } else {
              try {
                foundBooks(books);
              } catch(reason) {
                failure(reason);
              }
            }
          });
        } catch(error) {
          failure(err);
        }
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findAuthor().
      then(findBooksByAuthor).
      then(function(books){
        // found books
    }).catch(function(reason){
      // something went wrong
    });
    ```
  
    @method then
    @param {Function} onFulfilled
    @param {Function} onRejected
    Useful for tooling.
    @return {Promise}
  */
  then: then,

  /**
    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
    as the catch block of a try/catch statement.
  
    ```js
    function findAuthor(){
      throw new Error('couldn't find that author');
    }
  
    // synchronous
    try {
      findAuthor();
    } catch(reason) {
      // something went wrong
    }
  
    // async with promises
    findAuthor().catch(function(reason){
      // something went wrong
    });
    ```
  
    @method catch
    @param {Function} onRejection
    Useful for tooling.
    @return {Promise}
  */
  'catch': function _catch(onRejection) {
    return this.then(null, onRejection);
  }
};

function polyfill() {
    var local = undefined;

    if (typeof global !== 'undefined') {
        local = global;
    } else if (typeof self !== 'undefined') {
        local = self;
    } else {
        try {
            local = Function('return this')();
        } catch (e) {
            throw new Error('polyfill failed because global object is unavailable in this environment');
        }
    }

    var P = local.Promise;

    if (P) {
        var promiseToString = null;
        try {
            promiseToString = Object.prototype.toString.call(P.resolve());
        } catch (e) {
            // silently ignored
        }

        if (promiseToString === '[object Promise]' && !P.cast) {
            return;
        }
    }

    local.Promise = Promise;
}

// Strange compat..
Promise.polyfill = polyfill;
Promise.Promise = Promise;

return Promise;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13), __webpack_require__(4)))

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:no-any
// tslint:disable:no-unsafe-any
// tslint:disable:max-classes-per-file
// tslint:disable:variable-name
var Common_1 = __webpack_require__(3);
var Constants_1 = __webpack_require__(1);
var Logger_1 = __webpack_require__(0);
/**
 * Data for trouter response
 */
var ResponseData = /** @class */ (function () {
    function ResponseData(id) {
        this.id = id;
        this.status = 200;
        this.headers = {};
        this.body = '';
    }
    return ResponseData;
}());
exports.ResponseData = ResponseData;
// Possible telemetry events
var ClientEventName;
(function (ClientEventName) {
    ClientEventName["Connected"] = "trouter_js_client_connected";
    ClientEventName["Disconnected"] = "trouter_js_client_disconnected";
    ClientEventName["Error"] = "trouter_js_client_error";
    ClientEventName["Progress"] = "trouter_js_client_progress";
    ClientEventName["Response"] = "trouter_js_client_response";
    ClientEventName["Request"] = "trouter_js_client_request";
    ClientEventName["CheckConnection"] = "trouter_js_client_check_connection";
    ClientEventName["Registration"] = "trouter_js_client_registration";
    ClientEventName["Unregistration"] = "trouter_js_client_unregistration";
})(ClientEventName = exports.ClientEventName || (exports.ClientEventName = {}));
/**
 * Stores one step of connection process
 */
var TrackerStep = /** @class */ (function () {
    function TrackerStep(stepName, operation, delta, ts, error) {
        this.stepName = stepName;
        this.operation = operation;
        this.delta = delta;
        this.ts = ts;
        this.error = error;
    }
    return TrackerStep;
}());
exports.TrackerStep = TrackerStep;
/**
 * Base class for something that can be used as a property bag
 */
var Properties = /** @class */ (function () {
    function Properties() {
    }
    return Properties;
}());
exports.Properties = Properties;
/**
 * Information about connection
 */
var ConnectedInfo = /** @class */ (function () {
    function ConnectedInfo() {
        this.numberOfPingReplies = 0;
        this.connectedTimestamp = 0;
        this.isNewUrl = false;
        this.transportType = '';
        this.connectionNumber = 0;
    }
    return ConnectedInfo;
}());
/**
 * Default values for IEventLogSettings
 */
var EventLogSettings = /** @class */ (function () {
    function EventLogSettings() {
        this.enabled = false;
        this.numberOfStepsToMaintain = 40;
        this.logHealthCheckError = false;
        this.sendProgressTimeoutSecs = 55;
        this.logSendPingError = false;
        this.maxBackoffInMs = 120000;
        this.trouter_js_client_connected = false;
        this.trouter_js_client_disconnected = false;
        this.trouter_js_client_error = false;
        this.trouter_js_client_progress = false;
        this.trouter_js_client_response = false;
        this.trouter_js_client_request = false;
        this.trouter_js_client_registration = false;
        this.trouter_js_client_unregistration = false;
        /** This event is ENABLED by default */
        this.trouter_js_client_check_connection = true;
    }
    return EventLogSettings;
}());
/**
 * Telemetry sender
 */
var ConnectionTracker = /** @class */ (function () {
    function ConnectionTracker(logfunc, clientId, clientInfo, getServerState, endpointId, clientCorrelationID, environment) {
        this.clientId = clientId;
        this.clientInfo = clientInfo;
        this.getServerState = getServerState;
        this.endpointId = endpointId;
        this.clientCorrelationID = clientCorrelationID;
        this.environment = environment;
        this.logger = new Logger_1.Logger('ConnectionTracker', logfunc);
        this.clientCorrelationID = clientCorrelationID !== undefined ? clientCorrelationID : '';
        this.steps = [];
        this.connectionAttempt = 0;
        this.totalStepCount = 0;
        this.beginTimestamp = new Common_1.Timespan();
        this.eventLogSettings = new EventLogSettings();
        this.connectedInfo = new ConnectedInfo();
    }
    ConnectionTracker.prototype.enable = function (telemetrySender) {
        this.eventLogSettings.enabled = true;
        this.eventLogger = telemetrySender;
    };
    ConnectionTracker.prototype.disable = function () {
        this.eventLogSettings.enabled = false;
    };
    ConnectionTracker.prototype.sendProgress = function (context) {
        // connect truncates steps array. this check ensures that a progress event is only sent out if the client is not connected
        if (this.steps.length > 0) {
            this.sendTelemetry(ClientEventName.Progress, context, this.steps);
        }
    };
    ConnectionTracker.prototype.cancelProgressTimer = function () {
        if (this.progressTimeout !== undefined) {
            clearTimeout(this.progressTimeout);
            this.progressTimeout = undefined;
        }
    };
    ConnectionTracker.prototype.resetProgressSendTimer = function () {
        var _this = this;
        this.cancelProgressTimer();
        // send connection steps after a timeout
        // this timeout may fire if auth callback never comes or the client is stuck in a loop to get connected
        if (this.eventLogSettings.sendProgressTimeoutSecs !== undefined && this.eventLogSettings.sendProgressTimeoutSecs > 0) {
            this.progressTimeout = setTimeout(function () {
                _this.sendProgress({
                    reason: 'timeout',
                    timeoutSecs: _this.eventLogSettings.sendProgressTimeoutSecs
                });
            }, 1000 * this.eventLogSettings.sendProgressTimeoutSecs);
        }
    };
    ConnectionTracker.prototype.setConnectedInfo = function (isNewUrl, transportType) {
        this.connectedInfo.numberOfPingReplies = 0;
        this.connectedInfo.connectedTimestamp = Date.now();
        this.connectedInfo.isNewUrl = isNewUrl;
        this.connectedInfo.transportType = transportType;
        ++this.connectedInfo.connectionNumber;
    };
    ConnectionTracker.prototype.clearConnectedInfo = function () {
        this.connectedInfo.numberOfPingReplies = 0;
        this.connectedInfo.connectedTimestamp = 0;
        this.connectedInfo.isNewUrl = true;
        this.connectedInfo.transportType = '';
    };
    // Copies from
    // source {
    //    propName: value
    // }
    // to
    // dest {
    //    propName: { value: actualValue }
    // }
    ConnectionTracker.prototype.copyProperties = function (dest, source) {
        // copy properties from source and add in a format expected by logger
        for (var _i = 0, _a = Object.keys(source); _i < _a.length; _i++) {
            var prop = _a[_i];
            if (source.hasOwnProperty(prop) && source[prop] !== undefined) {
                // replace hyphen by _
                dest[prop.replace(/-/g, '_')] = { value: source[prop] };
            }
        }
    };
    ConnectionTracker.prototype.increasePingResponseCount = function () {
        ++this.connectedInfo.numberOfPingReplies;
    };
    /**
     * @param eventName Telemetry event name
     * @param eventProperties Event property bag
     * @param progress
     */
    ConnectionTracker.prototype.sendTelemetry = function (eventName, eventProperties, progress) {
        try {
            if (this.eventLogSettings.enabled === true
                && this.eventLogSettings[eventName] === true
                && this.eventLogger !== undefined) {
                var serverState = this.getServerState();
                var clientEvent = {
                    name: eventName,
                    properties: {
                        connectionAttempt: { value: this.connectionAttempt },
                        epid: { value: this.endpointId },
                        clientCorrelationID: { value: this.clientCorrelationID },
                        steps: { value: Common_1.toJson(progress) },
                        clientID: { value: this.clientId },
                        eventVersion: { value: 3 },
                        environment: { value: this.environment },
                        cv: { value: Constants_1.CLIENT_VERSION },
                        ua: { value: this.clientInfo.ua },
                        // Copy ServerState
                        connectionId: { value: serverState.connectionId },
                        connectedClientId: { value: serverState.connectedClientId },
                        domId: { value: serverState.domId },
                        url: { value: serverState.unsecureUrl },
                        surl: { value: serverState.url },
                        ttlInSecs: { value: serverState.getRemainingTtlInSec() },
                        // Copy this.connectedInfo
                        numberOfPingReplies: { value: this.connectedInfo.numberOfPingReplies },
                        connectedTimestamp: { value: this.connectedInfo.connectedTimestamp },
                        isNewUrl: { value: this.connectedInfo.isNewUrl },
                        transportType: { value: this.connectedInfo.transportType },
                        connectionNumber: { value: this.connectedInfo.connectionNumber }
                    }
                };
                this.copyProperties(clientEvent.properties, eventProperties);
                this.eventLogger.logEvent(clientEvent);
            }
        }
        catch (exc) {
            this.logger.warn("error in sending event " + eventName + ": " + Common_1.toJson(exc));
        }
    };
    ConnectionTracker.prototype.createStep = function (stepName, operation, error) {
        return new TrackerStep(stepName, operation, this.beginTimestamp.duration, Date.now(), error);
    };
    ConnectionTracker.prototype.addStep = function (tag, progressHint, error) {
        if (this.eventLogSettings.enabled === false) {
            return;
        }
        if (this.steps.length === 0) {
            this.beginTimestamp.reset();
        }
        this.steps.push(this.createStep(tag, progressHint, error));
        ++this.totalStepCount;
        // do not maintain an ever growing list of steps. send a progress event with what is collected so far and clear steps
        // there should be enough context in any event for the server to group events created for the sameonnection
        if (this.eventLogSettings.numberOfStepsToMaintain !== undefined
            && this.steps.length > this.eventLogSettings.numberOfStepsToMaintain) {
            var progress = this.steps.slice(0);
            this.steps.length = 0;
            this.sendTelemetry(ClientEventName.Progress, { reason: 'flush' }, progress);
        }
    };
    ConnectionTracker.prototype.trackStart = function (tag) {
        this.addStep(tag, 'start');
    };
    ConnectionTracker.prototype.trackEnd = function (tag) {
        this.addStep(tag, 'end');
    };
    ConnectionTracker.prototype.trackError = function (tag, error, addStep, subOperation) {
        if (addStep === void 0) { addStep = true; }
        if (tag === 'health' && this.eventLogSettings.logHealthCheckError !== true) {
            return;
        }
        if (tag === 'ping' && this.eventLogSettings.logSendPingError === false) {
            return;
        }
        if (subOperation === undefined) {
            subOperation = 'error';
        }
        if (addStep === true) {
            this.addStep(tag, subOperation, error);
        }
        this.sendTelemetry(ClientEventName.Error, {}, [this.createStep(tag, subOperation, error)]);
    };
    ConnectionTracker.prototype.trackProgress = function (tag, subOperation) {
        this.addStep(tag, subOperation);
    };
    ConnectionTracker.prototype.trackConnected = function (isNewUrl, transportType) {
        this.setConnectedInfo(isNewUrl, transportType);
        var progress = this.steps.slice(0);
        var totalSteps = this.totalStepCount;
        var connectionDuration = this.beginTimestamp.duration;
        // clear steps collected
        this.steps.length = 0;
        this.totalStepCount = 0;
        this.sendTelemetry(ClientEventName.Connected, {
            stepCount: progress.length,
            totalStepCount: totalSteps,
            connectionEstablishmentMs_Total: connectionDuration
        }, progress);
        this.cancelProgressTimer();
    };
    ConnectionTracker.prototype.getSessionLength = function () {
        return Date.now() - this.connectedInfo.connectedTimestamp;
    };
    ConnectionTracker.prototype.trackDisconnected = function (context) {
        context.sessionLengthMS = this.getSessionLength();
        this.sendTelemetry(ClientEventName.Disconnected, context, []);
        this.resetProgressSendTimer();
    };
    ConnectionTracker.prototype.trackNewConnection = function () {
        ++this.connectionAttempt;
    };
    ConnectionTracker.prototype.trackRequest = function (request, errorMsg) {
        var context = {};
        if (errorMsg !== undefined) {
            context.hasError = true;
            context.error = errorMsg;
        }
        try {
            if (request) {
                context.requestID = request.id;
                context.httpMethod = request.method;
                context.url = request.url;
                context.bodyLength = request.body.length;
                context.shortUrl = request.shortUrl;
                context.requestTimeStamp = request.startTS;
                context.correlationVector = request.correlationVector;
                var headers = request.headers;
                for (var _i = 0, _a = Object.keys(headers); _i < _a.length; _i++) {
                    var header = _a[_i];
                    if (headers.hasOwnProperty(header)) {
                        context[header] = headers[header];
                    }
                }
            }
        }
        catch (exc) {
            context.hasError = true;
            context.error = context.error + " error creating request context " + Common_1.toJson(exc);
        }
        this.sendTelemetry(ClientEventName.Request, context, []);
    };
    ConnectionTracker.prototype.trackResponse = function (request, latencyMS, responseData, errorMsg) {
        var context = {};
        if (errorMsg !== undefined) {
            context.hasError = true;
            context.error = errorMsg;
        }
        try {
            context.responseTimestamp = responseData !== undefined ? responseData.sentTS : Date.now();
            if (request) {
                context.requestID = request.id;
                context.httpMethod = request.method;
                context.shortUrl = request.shortUrl;
                context.correlationVector = request.correlationVector;
                var headers = request.headers;
                for (var _i = 0, _a = Object.keys(headers); _i < _a.length; _i++) {
                    var header = _a[_i];
                    if (headers.hasOwnProperty(header)) {
                        context[header] = headers[header];
                    }
                }
            }
            if (responseData) {
                context.latencyMS = latencyMS;
                context.responseCode = responseData.status;
                context.responseLength = responseData.body.length;
            }
        }
        catch (exc) {
            context.hasError = true;
            context.error = context.error + " error creating response context " + Common_1.toJson(exc);
        }
        this.sendTelemetry(ClientEventName.Response, context, []);
    };
    ConnectionTracker.prototype.sendResponseError = function (errorMsg, request, responseData) {
        this.trackResponse(request, undefined, responseData, errorMsg);
    };
    ConnectionTracker.prototype.close = function () {
        this.sendProgress({
            reason: 'closed'
        });
        this.steps.length = 0;
        this.cancelProgressTimer();
    };
    ConnectionTracker.prototype.mergeSettings = function (settings) {
        if (!settings) {
            return;
        }
        this.eventLogSettings.numberOfStepsToMaintain = Math.min(40, Math.max(10, (settings.numberOfStepsToMaintain !== undefined ? settings.numberOfStepsToMaintain : 0)));
        // min of 55 secs and max allowed is 1 hr
        var newProgressTimeout = Math.min(3600, Math.max(55, settings.sendProgressTimeoutSecs !== undefined ? settings.sendProgressTimeoutSecs : 0));
        this.eventLogSettings.logHealthCheckError = settings.logHealthCheckError;
        this.eventLogSettings.logSendPingError = settings.logSendPingError;
        // Copy enable/disable flags for all telemetry events
        for (var _i = 0, _a = Object.keys(ClientEventName).map(function (k) { return ClientEventName[k]; }); _i < _a.length; _i++) {
            var iterator = _a[_i];
            if (settings.hasOwnProperty(iterator) && settings[iterator] !== undefined) {
                this.eventLogSettings[iterator] = settings[iterator];
            }
        }
        if (this.eventLogSettings.sendProgressTimeoutSecs !== newProgressTimeout) {
            this.eventLogSettings.sendProgressTimeoutSecs = newProgressTimeout;
            this.resetProgressSendTimer();
        }
    };
    return ConnectionTracker;
}());
exports.ConnectionTracker = ConnectionTracker;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Executes callbacks with exponential backoff
 */
var ExponentialBackoff = /** @class */ (function () {
    function ExponentialBackoff(logger, maxBackoffInMs) {
        this.logger = logger;
        this.maxBackoffInMs = maxBackoffInMs;
        this.backoffId = 0;
        this.backoffCount = 0;
    }
    ExponentialBackoff.calculateNextBackoffMs = function (backoffCount, maxBackoffInMs) {
        // tslint:disable-next-line:insecure-random
        var fudge = 1 + (Math.random() - 0.5) * 0.4; // +/- 20%
        var backoff = 1000 * Math.pow(2, backoffCount) * fudge; // 1s initial
        backoff = Math.round(backoff);
        return Math.min(maxBackoffInMs, backoff);
    };
    ExponentialBackoff.prototype.setMaxBackoffMs = function (ms) {
        this.maxBackoffInMs = ms;
    };
    ExponentialBackoff.prototype.backoff = function (taskName, handler) {
        var _this = this;
        if (this.timerHandle !== undefined) {
            this.logger.debug('Clearing current back off');
            clearTimeout(this.timerHandle);
            this.timerHandle = undefined;
        }
        var backoffMs = ExponentialBackoff.calculateNextBackoffMs(this.backoffCount, this.maxBackoffInMs);
        this.backoffId++;
        this.backoffCount++;
        this.logger.info("Backing off " + taskName + " for " + backoffMs + " milliseconds with ID " + this.backoffId);
        this.callback = function () {
            _this.logger.info("Back off for " + taskName + " with ID " + _this.backoffId + " complete, invoking handler");
            _this.timerHandle = undefined;
            _this.callback = undefined;
            handler();
        };
        this.timerHandle = setTimeout(this.callback, backoffMs);
    };
    /// Stop the backoff if active, do not call the handler and reset to the initial/shortest period again
    ExponentialBackoff.prototype.reset = function () {
        if (this.timerHandle !== undefined) {
            this.logger.debug("Resetting back off with ID " + this.backoffId);
            clearTimeout(this.timerHandle);
            this.timerHandle = undefined;
            this.callback = undefined;
        }
        this.backoffCount = 0;
    };
    /// Call the handler right now if active and reset to the initial/shortest period again
    ExponentialBackoff.prototype.expediteIfPending = function () {
        this.backoffCount = 0;
        if (this.timerHandle !== undefined) {
            this.logger.debug("Expediting back off with ID " + this.backoffId);
            clearTimeout(this.timerHandle);
            this.timerHandle = undefined;
            var callback = this.callback;
            this.callback = undefined;
            if (callback) {
                callback();
            }
        }
    };
    return ExponentialBackoff;
}());
exports.ExponentialBackoff = ExponentialBackoff;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var InternalInterfaces_1 = __webpack_require__(5);
var Logger_1 = __webpack_require__(0);
/**
 * After this count of 'soft' (5XX, no response) connection errors, FSM will start a new allocation.
 * Doesn't apply for 'hard' errors like 4XX, in this case FSM will start a new allocation immediately.
 */
var MAXIMUM_CONNECTION_ERRORS_COUNT = 2;
var State;
(function (State) {
    State[State["Initial"] = 0] = "Initial";
    /** waiting for token from User */
    State[State["RetrievingToken"] = 1] = "RetrievingToken";
    /** waiting for allocation response from service */
    State[State["Allocating"] = 2] = "Allocating";
    /**
     * waiting for Socket.IO handshake to be finished. After that Socket.IO will
     * start to try transports and send 'connecting' event
     */
    State[State["Handshaking"] = 3] = "Handshaking";
    /**
     * waiting for 'connected' event - socket.io is trying different transports.
     * onSocketError event should be ignored, as it's expected event. So, only ConnectFailed or
     * connection timeout meas failed connection
     */
    State[State["Connecting"] = 4] = "Connecting";
    /** ready to work */
    State[State["Connected"] = 5] = "Connected";
    /** waiting for token from User to send 'unregister' request */
    State[State["UnregisteringRetrievingToken"] = 6] = "UnregisteringRetrievingToken";
    /** waiting for succesful 'unregister' response */
    State[State["Unregistering"] = 7] = "Unregistering";
    /**
     * Unrecoverable state
     * Trouter cannot start once in this state
     */
    State[State["TerminalError"] = 8] = "TerminalError";
})(State = exports.State || (exports.State = {}));
var ConnectedSubstate;
(function (ConnectedSubstate) {
    ConnectedSubstate[ConnectedSubstate["Initial"] = 0] = "Initial";
    /** waiting for token from User */
    ConnectedSubstate[ConnectedSubstate["RetrievingToken"] = 1] = "RetrievingToken";
    /** waiting for succesful 'register' response */
    ConnectedSubstate[ConnectedSubstate["Registering"] = 2] = "Registering";
    /** Registration succeed */
    ConnectedSubstate[ConnectedSubstate["Registered"] = 3] = "Registered";
    /** Registration is skipped */
    ConnectedSubstate[ConnectedSubstate["NotRegistered"] = 4] = "NotRegistered";
})(ConnectedSubstate || (ConnectedSubstate = {}));
/**
 * State machine for trouter
 */
var TrouterFsm = /** @class */ (function () {
    function TrouterFsm(logfunc, worker, incallModeEnabled) {
        this.worker = worker;
        this.incallModeEnabled = incallModeEnabled;
        this.state = State.Initial;
        this.autoReconnect = true;
        this.logger = new Logger_1.Logger('ConnectionFsm', logfunc);
        this.connectedSubstate = ConnectedSubstate.Initial;
    }
    /** Returns current state */
    TrouterFsm.prototype.getState = function () {
        return this.state;
    };
    TrouterFsm.prototype.isActive = function () {
        return this.state === State.Allocating
            || this.state === State.Connected
            || this.state === State.Handshaking
            || this.state === State.Connecting
            || this.state === State.RetrievingToken;
    };
    //////////// Events ////////////
    /**
     * Start trouter
     */
    TrouterFsm.prototype.start = function () {
        if (this.state === State.Initial) {
            this.setState(State.RetrievingToken);
            this.worker.getToken(true, false);
            return true;
        }
        else {
            this.showIgnored('start');
            return false;
        }
    };
    /**
     * Stop trouter
     * @param dontUnregister    if true, FSM will not unregister. It's needed in case of two simultaneous
     *                          connections, to replace first connection with second - registrar just updates
     *                          the existing record for the user, by registrationId (see their API docs),
     *                          that id does not change during the lifetime of a TrouterService instance.
     */
    TrouterFsm.prototype.stop = function (dontUnregister) {
        if (dontUnregister) {
            this.connectedSubstate = ConnectedSubstate.Initial;
        }
        if (this.worker.isIncallMode()) {
            this.worker.exitIncallMode();
        }
        this.worker.resetTokenBackoff();
        this.worker.resetRegisterBackoff();
        this.worker.stopConnectionTimer();
        this.worker.stopPingTimer();
        this.worker.clearTimers();
        this.worker.stopRegisterTimer();
        if (this.state === State.Connecting
            || this.state === State.Handshaking
            || this.state === State.Connected) {
            this.worker.stopSocketIo();
            if (this.state === State.Connected) {
                this.worker.sendDisconnectTelemetryEvent('connection stopped');
            }
        }
        // Stop can happen in any state - the only difference is if registration exists or not.
        // It can be also called a second time, just to stop a stuck unregistration.
        if (this.isRegistered() && this.state !== State.UnregisteringRetrievingToken && this.state !== State.Unregistering) {
            this.setState(State.UnregisteringRetrievingToken);
            this.worker.getToken(true, false);
        }
        else {
            this.setState(State.Initial);
            this.worker.dispatchDisconnected();
        }
    };
    TrouterFsm.prototype.onTokenReceived = function (token) {
        if (this.state === State.RetrievingToken) {
            this.setState(State.Allocating);
            this.worker.startConnectionTimer();
            this.worker.sendAllocateRequest(token);
        }
        else if (this.state === State.Connected && this.connectedSubstate === ConnectedSubstate.RetrievingToken) {
            this.connectedSubstate = ConnectedSubstate.Registering;
            this.worker.sendRegisterRequest();
        }
        else if (this.state === State.UnregisteringRetrievingToken) {
            this.setState(State.Unregistering);
            this.worker.sendUnregisterRequest();
        }
        else {
            this.showIgnored('onTokenReceived');
        }
    };
    /**
     * if disconnectDetected - need to send ping to check if connection is really dead,
     * otherwise - network is available
     */
    TrouterFsm.prototype.checkConnection = function (disconnectDetected) {
        if (disconnectDetected) {
            this.onPingInterval();
        }
    };
    /** Allocation request succeed with 200 */
    TrouterFsm.prototype.onAllocationSucceed = function () {
        if (this.state === State.Allocating) {
            this.setState(State.Handshaking);
            if (this.connectedSubstate === ConnectedSubstate.Registered) {
                this.worker.dispatchUnregistered();
            }
            this.connectedSubstate = ConnectedSubstate.Initial;
            this.worker.startSocketIo();
            return true;
        }
        else {
            this.showIgnored('onAllocationSucceed');
            return false;
        }
    };
    /** Allocation request failed */
    TrouterFsm.prototype.onAllocationFailed = function (unauthorized) {
        if (this.state === State.Allocating) {
            this.setState(State.RetrievingToken);
            this.worker.stopConnectionTimer();
            this.worker.getToken(!unauthorized, true);
        }
        else {
            this.showIgnored('onAllocationFailed');
        }
    };
    /** Connection didn't succeed in given timeout */
    TrouterFsm.prototype.onConnectingTimeout = function () {
        // implementation note: this also called from onConnectingFailed
        if (this.state === State.Allocating
            || this.state === State.Connecting
            || this.state === State.Handshaking) {
            this.setState(State.RetrievingToken);
            this.worker.stopSocketIo();
            this.worker.getToken(true, false);
        }
        else {
            this.showIgnored('onConnectingTimeout');
        }
    };
    /** socket.io handshake succeed and socket.io is trying next transport */
    TrouterFsm.prototype.onConnecting = function () {
        if (this.state === State.Handshaking) {
            this.setState(State.Connecting);
        }
        else {
            this.showIgnored('onConnecting');
        }
    };
    /** Socket.io connection wasn't established */
    TrouterFsm.prototype.onConnectingFailed = function () {
        // This callback will be called when all transports failed to connect, i.e. socket.io can't proceed
        if (this.state === State.Connecting) {
            this.onConnectingTimeout();
        }
        else if (this.state === State.Handshaking) {
            // It should never happen, because socket.io should try at least one transport
            this.logger.error('Unexpected error in Socket.io - no valid transports');
            this.onConnectingTimeout();
        }
        else {
            this.showIgnored('onConnectingFailed');
        }
    };
    /** Socket.io error (or disconnect) */
    TrouterFsm.prototype.onSocketDisconnect = function (disconnectReason) {
        if (this.state === State.Handshaking || this.state === State.Connected) {
            this.worker.stopSocketIo();
            this.worker.stopPingTimer();
            this.worker.clearTimers();
            this.worker.stopConnectionTimer();
            if (this.state === State.Connected) {
                this.worker.sendDisconnectTelemetryEvent(disconnectReason);
            }
            if (this.autoReconnect) {
                this.setState(State.RetrievingToken);
                this.worker.resetRegisterBackoff();
                this.worker.dispatchReconnecting();
                this.worker.getToken(true, false);
            }
            else {
                this.logger.debug('Socket error/disconnect occurred and automatic reconnect is disabled. Connection will stop.');
                this.stop(true);
            }
        }
        else {
            // Disconnect can be called because of an error.
            // Such error can happen in Connecting state, which means that
            // websocket transport failed to establish connection
            this.showIgnored('onSocketDisconnect');
        }
    };
    /** Received 'trouter.connected' event from service */
    TrouterFsm.prototype.onTrouterConnected = function () {
        if (this.state === State.Connecting) {
            this.setState(State.Connected);
            this.worker.resetTokenBackoff();
            this.worker.stopConnectionTimer();
            this.worker.sendUserActivityState(InternalInterfaces_1.UserActivityEventReason.Connected, true);
            this.worker.startPingTimer();
            this.worker.dispatchConnected();
            if (this.worker.shouldSkipRegistration()) {
                this.connectedSubstate = ConnectedSubstate.NotRegistered;
                this.worker.dispatchRegistered();
            }
            else {
                this.connectedSubstate = ConnectedSubstate.RetrievingToken;
                this.worker.getToken(true, false);
            }
        }
        else {
            this.showIgnored('onTrouterConnected');
        }
    };
    /**
     * Received 'trouter.reconnect' event from service, or URL in configuration has changed,
     * need to establish a new connection
     */
    TrouterFsm.prototype.onReconnectRequired = function (useConnectParamsFromCache, reason) {
        this.worker.dispatchReconnectIsRequired(useConnectParamsFromCache, reason);
    };
    TrouterFsm.prototype.disableAutoReconnect = function () {
        this.autoReconnect = false;
    };
    /** Request from downstream is received */
    TrouterFsm.prototype.onDownstreamRequest = function (request) {
        if (this.state === State.Connected) {
            this.switchToIncallModeIfEnabled();
            this.worker.dispatchDownstreamRequest(request);
        }
        else {
            this.showIgnored('onDownstreamRequest');
        }
    };
    TrouterFsm.prototype.onTrouterMessageLost = function (messageLossIndicators) {
        if (this.state === State.Connected) {
            this.worker.dispatchTrouterMessageLost(messageLossIndicators);
        }
        else {
            this.showIgnored('onTrouterMessageLost');
        }
    };
    /** Timer for ping request fired */
    TrouterFsm.prototype.onPingInterval = function () {
        if (this.state === State.Connected) {
            this.worker.sendPingRequest();
        }
        else {
            this.showIgnored('onPingInterval');
        }
    };
    /** No pong response from service within timeout */
    TrouterFsm.prototype.onPingResponseTimeout = function () {
        this.onMissedResponse('onPingResponseTimeout');
    };
    /** Pong response */
    TrouterFsm.prototype.onPingResponse = function () {
        if (this.state === State.Connected) {
            // do nothing
        }
        else {
            this.showIgnored('onPingResponse');
        }
    };
    TrouterFsm.prototype.onRegistrationFailed = function (unauthorized) {
        if (this.state === State.Connected
            && this.connectedSubstate === ConnectedSubstate.Registering) {
            this.connectedSubstate = ConnectedSubstate.RetrievingToken;
            this.worker.getToken(!unauthorized, true);
        }
        else {
            this.showIgnored('onRegistrationFailed');
        }
    };
    TrouterFsm.prototype.onRegistrationSucceed = function (isRegistrationTtlLowerThanKnownAllocationTtl) {
        if (this.state === State.Connected) {
            if (this.connectedSubstate === ConnectedSubstate.Registering) {
                this.connectedSubstate = ConnectedSubstate.Registered;
                this.worker.dispatchRegistered();
            }
            // If registration ttl is lower than known allocation ttl we need to start re-registration.
            // Otherwise, the allocation will expire with the registration, client will reconnect with a new
            // allocation, a new connection id. which in turn will trigger a new registration started.
            // i.e. no need to re-register the current expiring one.
            if (isRegistrationTtlLowerThanKnownAllocationTtl) {
                this.worker.startRegisterTimer();
            }
        }
        else {
            this.showIgnored('onRegistrationSucceed');
        }
    };
    /** Registration TTL is about to expire */
    TrouterFsm.prototype.onRegistrationTimeout = function () {
        if (this.state === State.Connected
            && this.connectedSubstate !== ConnectedSubstate.NotRegistered) {
            this.connectedSubstate = ConnectedSubstate.RetrievingToken;
            this.worker.getToken(true, false);
        }
        else {
            this.showIgnored('onRegistrationTimeout');
        }
    };
    TrouterFsm.prototype.onUnregistrationFailed = function (unauthorized) {
        if (this.state === State.Unregistering) {
            this.setState(State.UnregisteringRetrievingToken);
            this.worker.getToken(!unauthorized, !unauthorized);
        }
        else {
            this.showIgnored('onUnregistrationFailed');
        }
    };
    TrouterFsm.prototype.onUnregistrationSucceed = function () {
        if (this.state === State.Unregistering) {
            this.setState(State.Initial);
            this.worker.dispatchUnregistered();
            this.worker.dispatchDisconnected();
        }
        else {
            this.showIgnored('onUnregistrationSucceed');
        }
    };
    TrouterFsm.prototype.onIncallModeTimer = function () {
        this.worker.exitIncallMode();
        if (this.state === State.Connected) {
            this.worker.stopPingTimer();
            this.worker.startPingTimer();
        }
        else {
            this.showIgnored('onIncallModeTimer');
        }
    };
    TrouterFsm.prototype.onSetUserActivityState = function (userActivityObject, changed) {
        if (changed) {
            this.logger.info("Changing user activity state to '" + userActivityObject.toEventJSON() + "'");
            this.worker.sendUserActivityState(InternalInterfaces_1.UserActivityEventReason.Modified, this.state === State.Connected);
        }
        else {
            this.logger.debug("Not changing the same user activity state '" + userActivityObject.toEventJSON() + "'");
        }
    };
    TrouterFsm.prototype.onActivityStateResponseTimeout = function () {
        this.onMissedResponse('onActivityStateResponseTimeout');
    };
    TrouterFsm.prototype.forceReconnect = function (reason) {
        if (this.state === State.Connected) {
            this.worker.sendDisconnectTelemetryEvent(reason);
        }
        this.setState(State.RetrievingToken);
        this.worker.resetTokenBackoff();
        this.worker.stopConnectionTimer();
        this.worker.resetRegisterBackoff();
        this.worker.stopPingTimer();
        this.worker.clearTimers();
        this.worker.stopSocketIo();
        this.worker.dispatchReconnecting();
        this.worker.getToken(true, false);
    };
    TrouterFsm.prototype.onTerminalError = function () {
        this.logger.error("Cannot proceed, reached terminal state. Switching from state '" + State[this.state] + "' to " + State[State.TerminalError]);
        this.setState(State.TerminalError);
    };
    TrouterFsm.prototype.onMissedResponse = function (onResponseHandlerName) {
        if (this.state === State.Connected) {
            this.setState(State.RetrievingToken);
            this.worker.resetRegisterBackoff();
            this.worker.stopPingTimer();
            this.worker.clearTimers();
            this.worker.stopSocketIo();
            this.worker.sendDisconnectTelemetryEvent(onResponseHandlerName);
            this.worker.dispatchReconnecting();
            this.worker.getToken(true, false);
        }
        else {
            this.showIgnored(onResponseHandlerName);
        }
    };
    TrouterFsm.prototype.showIgnored = function (event) {
        this.logger.debug("Ignoring event '" + event + "' in state '" + State[this.state] + "'");
    };
    TrouterFsm.prototype.setState = function (state) {
        this.logger.info("Switching from state '" + State[this.state] + "' to state '" + State[state] + "'");
        if (this.state === state) {
            this.logger.error("Attempt to switching into the current state '" + State[state] + "'");
            return;
        }
        this.state = state;
    };
    TrouterFsm.prototype.isRegistered = function () {
        return this.connectedSubstate === ConnectedSubstate.Registered
            || this.connectedSubstate === ConnectedSubstate.Registering;
    };
    TrouterFsm.prototype.switchToIncallModeIfEnabled = function () {
        if (this.incallModeEnabled) {
            if (!this.worker.isIncallMode()) {
                this.worker.enterIncallMode();
                this.worker.stopPingTimer();
                this.worker.startPingTimer();
            }
            this.worker.restartIncallModeTimer();
        }
    };
    return TrouterFsm;
}());
exports.TrouterFsm = TrouterFsm;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Interfaces_1 = __webpack_require__(2);
var Logger_1 = __webpack_require__(0);
var TrouterConnection_1 = __webpack_require__(6);
/**
 * State machine for manager
 */
var TrouterManagerFsm = /** @class */ (function () {
    function TrouterManagerFsm(logFunc, worker) {
        this.worker = worker;
        this.state = Interfaces_1.TrouterState.Unknown;
        this.logger = new Logger_1.Logger('ManagerFsm', logFunc);
    }
    TrouterManagerFsm.prototype.start = function () {
        if (this.state === Interfaces_1.TrouterState.Unknown) {
            this.setState(Interfaces_1.TrouterState.Disconnected);
            this.worker.forceStopLingeringConnection();
            this.worker.startFirstConnection();
        }
        else {
            this.showIgnored('start');
        }
    };
    TrouterManagerFsm.prototype.stop = function (dontUnregister) {
        if (this.state !== Interfaces_1.TrouterState.Unknown) {
            this.setState(Interfaces_1.TrouterState.Unknown);
            this.worker.stopFirstConnection(dontUnregister === true);
            this.worker.stopSecondConnection(dontUnregister === true);
        }
        else {
            this.showIgnored('stop');
        }
    };
    /** Returns current state */
    TrouterManagerFsm.prototype.getState = function () {
        return this.state;
    };
    TrouterManagerFsm.prototype.onConnected = function (first) {
        if (this.state === Interfaces_1.TrouterState.Disconnected && first) {
            if (this.worker.doesSecondConnectionExist()) {
                this.setState(Interfaces_1.TrouterState.Switching);
            }
            else {
                this.setState(Interfaces_1.TrouterState.Connected);
                this.worker.dispatchConnected();
            }
        }
        else {
            this.showIgnored("onConnected(" + first + ")");
        }
    };
    TrouterManagerFsm.prototype.onRegistered = function (first) {
        if (this.state === Interfaces_1.TrouterState.Disconnected && !first) {
            this.setState(Interfaces_1.TrouterState.Connected);
            this.worker.switchConnections();
            this.worker.stopSecondConnection(true);
            this.worker.dispatchConnected();
        }
        else if (this.state === Interfaces_1.TrouterState.Switching && !first) {
            this.setState(Interfaces_1.TrouterState.Connected);
            this.worker.switchConnections();
            this.worker.stopSecondConnectionDelayed();
            this.worker.dispatchConnected();
        }
        this.worker.dispatchRegistrationState(true);
    };
    TrouterManagerFsm.prototype.onUnregistered = function (first) {
        if (first) {
            this.worker.dispatchRegistrationState(false);
        }
    };
    TrouterManagerFsm.prototype.onReconnecting = function (first) {
        if (this.state === Interfaces_1.TrouterState.Connected && first) {
            this.setState(Interfaces_1.TrouterState.Disconnected);
            this.worker.dispatchReconnecting();
        }
        else if (this.state === Interfaces_1.TrouterState.Switching && first) {
            this.setState(Interfaces_1.TrouterState.Disconnected);
            this.worker.dispatchReconnecting();
        }
        else {
            this.showIgnored("onReconnecting(" + first + ")");
        }
    };
    TrouterManagerFsm.prototype.onReconnectionRequired = function (first, useConnectParamsFromCache, reason) {
        if (this.state === Interfaces_1.TrouterState.Connected && first) {
            this.setState(Interfaces_1.TrouterState.Switching);
            this.worker.startSecondConnection(useConnectParamsFromCache);
        }
        else if (this.state === Interfaces_1.TrouterState.Disconnected && first) {
            this.worker.startSecondConnection(useConnectParamsFromCache);
        }
        else if (this.state === Interfaces_1.TrouterState.Switching && first && reason === TrouterConnection_1.ReconnectReason.Configuration) {
            // Intentionally ignoring `trouter.reconnect` events arriving during an in-progress switch (on either connection),
            // only configuration change is handled. This matches the current behavior of the C++ client.
            // Even in the ignored cases, the client should still end up being connected to the right environment eventually.
            this.logger.debug('onReconnectionRequired: switch requested while already in Switching state');
            this.worker.stopSecondConnection(true);
            this.worker.startSecondConnection(useConnectParamsFromCache);
        }
        else {
            this.showIgnored("onReconnectionRequired(" + first + ")");
        }
    };
    TrouterManagerFsm.prototype.onDisconnected = function (first) {
        if (this.state === Interfaces_1.TrouterState.Unknown && first) {
            this.worker.dispatchStopped();
        }
        else {
            this.showIgnored("onDisconnected(" + first + ")");
        }
    };
    TrouterManagerFsm.prototype.showIgnored = function (event) {
        this.logger.info("Ignoring event '" + event + "' in state '" + Interfaces_1.TrouterState[this.state] + "'");
    };
    TrouterManagerFsm.prototype.setState = function (state) {
        this.logger.info("Switching from state '" + Interfaces_1.TrouterState[this.state] + "' to state '" + Interfaces_1.TrouterState[state] + "'");
        if (this.state === state) {
            this.logger.error("Attempt to switching into the current state '" + Interfaces_1.TrouterState[state] + "'");
            return;
        }
        this.state = state;
    };
    return TrouterManagerFsm;
}());
exports.TrouterManagerFsm = TrouterManagerFsm;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 */
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:strict-boolean-expressions
var Constants_1 = __webpack_require__(1);
var Interfaces_1 = __webpack_require__(2);
exports.TrouterState = Interfaces_1.TrouterState;
exports.UserActivityState = Interfaces_1.UserActivityState;
var Logger_1 = __webpack_require__(0);
var MessageHandler_1 = __webpack_require__(7);
var SkypeTokenProviderWithCache_1 = __webpack_require__(8);
var TrouterManager_1 = __webpack_require__(9);
var TrouterUrlPromise_1 = __webpack_require__(10);
function populateTelemetryOptions(startingCfg, ecsCfg) {
    if (!ecsCfg) {
        return startingCfg;
    }
    var res = __assign({}, startingCfg, {
        enabled: ecsCfg.TelemetryEnabled
    });
    if (ecsCfg.ClientTelemetryEventEnabled !== undefined) {
        res = __assign({}, res, ecsCfg.ClientTelemetryEventEnabled);
    }
    return res;
}
function populateTrouterOptions(cfg, ecsCfg) {
    return {
        clientInfo: {
            ua: cfg.trouterSettings.productName,
            v: cfg.trouterSettings.version
        },
        ioOptions: {
            // uncomment for manual testing
            // transports: ['xhr-polling'],
            // 'connect timeout': XXX, 10000 by default in socket.io code
            ackTimeoutMs: 5000
        },
        clientCorrelationID: cfg.trouterSettings.sessionId,
        environment: cfg.trouterSettings.environment,
        telemetrySettings: populateTelemetryOptions(cfg.telemetryConfig.settings, ecsCfg),
        eventLogger: cfg.telemetryConfig.eventLogger,
        endpointId: cfg.trouterSettings.registrationId,
        trouterUrl: (ecsCfg && ecsCfg.TrouterConnectionUrl) || cfg.trouterSettings.trouterServiceUrl,
        registration: cfg.trouterSettings.registrarServiceUrl
            ? {
                registrarUrl: cfg.trouterSettings.registrarServiceUrl,
                registrationId: cfg.trouterSettings.registrationId || '',
                pnhAppId: cfg.trouterSettings.pnhAppId || '',
                platform: cfg.trouterSettings.platform || '',
                pnhTemplateKey: cfg.trouterSettings.pnhTemplate || '',
                platformUIVersion: cfg.trouterSettings.platformUIVersion || '',
                productContext: cfg.trouterSettings.pnhProductContext || undefined,
                context: cfg.trouterSettings.pnhContext || '',
                registrarTtlSec: (cfg.trouterSettings.maxRegistrationTimeInMs || 0) / 1000
            }
            : undefined,
        timeoutOptions: __assign({ connectionTimeoutMs: cfg.trouterSettings.trouterConnectTimeoutInMs || 30000, fetchTimeoutMs: 10000, pingTimeoutMs: 40000, pongTimeoutMs: 5000, 
            /** Followup WI to remove hardcoded value: https://domoreexp.visualstudio.com/MSTeams/_workitems/edit/2307271 */
            maxBackoffMs: cfg.trouterSettings.productName === 'TeamsCDL' ? 300000 : 30000, requestTimeoutMs: 5000, userActivityResponseTimeoutMs: 10000 }, cfg.trouterSettings.timeoutOptions),
        incallTimeoutOptions: __assign({ connectionTimeoutMs: 10000, fetchTimeoutMs: 5000, pingTimeoutMs: 5000, pongTimeoutMs: 2000, maxBackoffMs: cfg.trouterSettings.productName === 'TeamsCDL' ? 300000 : 10000, requestTimeoutMs: 5000, userActivityResponseTimeoutMs: 10000 }, cfg.trouterSettings.incallTimeoutOptions),
        incallModeTimeoutMs: cfg.trouterSettings.incallModeTimeoutMs || 0,
        lingeringConnectionDelayMs: 60000,
        userActivitySecondResendDelayMs: cfg.trouterSettings.userActivitySecondResendDelayMs || 10000,
        duplicateDisconnectThresholdMs: 10000,
        connectionCache: cfg.connectionCache,
        registrationStateCallback: cfg.registrationStateCallbackForAcsDoNotUse,
        retryLimitOnTokenFetch: cfg.trouterSettings.productName === 'TeamsCDL' ? 15 : cfg.trouterSettings.retryLimitOnTokenFetch
    };
}
/**
 * TrouterService implementation class
 */
var TrouterService = /** @class */ (function () {
    function TrouterService(logProvider) {
        this.logProvider = logProvider;
        this.stateChangedListeners = [];
        this.logger = new Logger_1.Logger('Trouter', logProvider);
        this.trouterUrlPromise = new TrouterUrlPromise_1.TrouterUrlPromise(logProvider);
        this.messageHandlers = new MessageHandler_1.MessageHandlerRegistry(logProvider);
        this.listeners = {};
        this.connectionInfo = null;
        this.logger.info("Created TrouterService version " + Constants_1.CLIENT_VERSION);
    }
    TrouterService.prototype.start = function (cfg) {
        this.logger.info('Start');
        if (!cfg.trouterSettings.disableInternalSkypeTokenCache) {
            var provider = cfg.skypeTokenProvider;
            cfg.skypeTokenProvider = SkypeTokenProviderWithCache_1.addCacheAsBackupTo(provider);
        }
        this.trouterCfg = cfg;
        var options = populateTrouterOptions(cfg, this.ecsCfg);
        if (this.trouterServer === undefined) {
            this.trouterServer = new TrouterManager_1.TrouterManager(this.logProvider, options, cfg.skypeTokenProvider, this);
        }
        this.trouterServer.start();
    };
    TrouterService.prototype.stop = function (dontUnregister) {
        this.logger.info('close connection');
        this.trouterUrlPromise.rejectUrl(new Error('TrouterService is stopped'));
        if (this.trouterServer !== undefined) {
            this.trouterServer.stop(dontUnregister);
        }
    };
    TrouterService.prototype.setEcsConfig = function (fullEcsData) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var ecsSection = 'TrouterJScriptClient';
                        _this.ecsCfg = (fullEcsData[ecsSection]);
                        _this.logger.info("Setting ECS configuration to " + JSON.stringify(_this.ecsCfg));
                        if (_this.trouterServer !== undefined && _this.trouterCfg !== undefined) {
                            var options = populateTrouterOptions(_this.trouterCfg, _this.ecsCfg);
                            _this.trouterServer.configure(options);
                        }
                        resolve();
                    })];
            });
        });
    };
    /**
     * Notifies trouter that network is restored - trouter will try to restore connection immediately
     */
    TrouterService.prototype.checkConnection = function (disconnectDetected) {
        if (this.trouterServer !== undefined) {
            this.trouterServer.checkConnection(disconnectDetected || false);
        }
    };
    TrouterService.prototype.resendRegistration = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.trouterServer) {
                    throw new Error('resendRegistration called too early');
                }
                return [2 /*return*/, this.trouterServer.resendRegistration()];
            });
        });
    };
    // Listeners
    TrouterService.prototype.registerListener = function (listener, path) {
        if (path === '' || path[0] !== '/' || path.indexOf('?') >= 0 || path.indexOf('#') >= 0) {
            this.logger.error("Listener path '" + path + "' is not valid");
            return false;
        }
        if (this.listeners[path]) {
            this.logger.error("Another listener is already registered for path '" + path + "'");
            return false;
        }
        this.listeners[path] = listener;
        this.logger.debug("Listener for path '" + path + "' registered");
        if (this.connectionInfo) {
            listener.onTrouterConnected(this.connectionInfo.baseEndpointUrl + path, this.connectionInfo);
        }
        return true;
    };
    TrouterService.prototype.unregisterListener = function (listener) {
        var paths = [];
        for (var _i = 0, _a = Object.keys(this.listeners); _i < _a.length; _i++) {
            var path = _a[_i];
            if (this.listeners[path] === listener) {
                paths.push(path);
            }
        }
        if (paths.length === 0) {
            return false;
        }
        for (var _b = 0, paths_1 = paths; _b < paths_1.length; _b++) {
            var path = paths_1[_b];
            delete this.listeners[path];
        }
        this.logger.debug("Listener for path(s) '" + paths.join('\', \'') + "' unregistered");
        return true;
    };
    TrouterService.prototype.onTrouterConnected = function (endpointUrl, connectionInfo) {
        this.logger.debug('Trouter is now connected');
        for (var _i = 0, _a = Object.keys(this.listeners); _i < _a.length; _i++) {
            var path = _a[_i];
            try {
                this.listeners[path].onTrouterConnected(connectionInfo.baseEndpointUrl + path, connectionInfo);
            }
            catch (e) {
                this.logger.error("Listener '" + path + "' threw an exception from onTrouterConnected(): " + e);
            }
        }
        this.connectionInfo = connectionInfo;
        this.trouterUrlPromise.resolveUrl(endpointUrl);
        this.notifyStateChanged(Interfaces_1.TrouterState.Connected, {
            url: endpointUrl,
            getRemainingTtlInSec: function () { return connectionInfo.connectionTtlSec; }
        });
    };
    TrouterService.prototype.onTrouterDisconnected = function () {
        this.logger.debug('Trouter is now disconnected');
        this.connectionInfo = null;
        for (var _i = 0, _a = Object.keys(this.listeners); _i < _a.length; _i++) {
            var path = _a[_i];
            var listener = this.listeners[path];
            if (listener.onTrouterDisconnected) {
                try {
                    listener.onTrouterDisconnected();
                }
                catch (e) {
                    this.logger.error("Listener '" + path + "' threw an exception from onTrouterDisconnected(): " + e);
                }
            }
        }
        this.notifyStateChanged(Interfaces_1.TrouterState.Disconnected);
    };
    TrouterService.prototype.onTrouterRequest = function (request, response) {
        var bestPath = '';
        for (var _i = 0, _a = Object.keys(this.listeners); _i < _a.length; _i++) {
            var path = _a[_i];
            if (request.path.substring(0, path.length) === path && path.length > bestPath.length) {
                bestPath = path;
            }
        }
        if (bestPath !== '') {
            try {
                this.listeners[bestPath].onTrouterRequest(request, response);
            }
            catch (e) {
                this.logger.error("Listener '" + bestPath + "' threw an exception from onTrouterRequest(): " + e);
                response.status = 500;
                response.headers = { 'Trouter-Responder': 'ClientLib' };
                response.send();
            }
            return;
        }
        if (this.tryMessageHandlers(request, response)) {
            return;
        }
        response.status = 404;
        response.headers = { 'Trouter-Responder': 'ClientLib' };
        response.send();
    };
    TrouterService.prototype.onTrouterMessageLoss = function (flowTags) {
        this.logger.info("onTrouterMessageLoss called with value " + flowTags);
        var messageLossProcessed = true;
        for (var _i = 0, _a = Object.keys(this.listeners); _i < _a.length; _i++) {
            var path = _a[_i];
            var listener = this.listeners[path];
            if (listener.onTrouterMessageLoss) {
                try {
                    messageLossProcessed = listener.onTrouterMessageLoss(flowTags) && messageLossProcessed;
                    if (messageLossProcessed === undefined) {
                        this.logger.error("Listener '" + path + "' did not response with boolean value onTrouterMessageLoss()");
                        messageLossProcessed = false;
                    }
                }
                catch (e) {
                    this.logger.error("Listener '" + path + "' threw an exception from onTrouterMessageLoss(): " + e);
                    messageLossProcessed = false;
                }
            }
        }
        return messageLossProcessed;
    };
    TrouterService.prototype.onTrouterUserActivityStateAccepted = function (cv) {
        this.logger.debug("onTrouterUserActivityStateAccepted cv: " + cv);
        for (var _i = 0, _a = Object.keys(this.listeners); _i < _a.length; _i++) {
            var path = _a[_i];
            var listener = this.listeners[path];
            if (listener.onTrouterUserActivityStateAccepted) {
                try {
                    listener.onTrouterUserActivityStateAccepted(cv);
                }
                catch (e) {
                    this.logger.error("Listener '" + path + "' threw an exception from onTrouterUserActivityStateAccepted(): " + e);
                }
            }
        }
    };
    TrouterService.prototype.setUserActivityState = function (state, correlationVector) {
        if (state !== Interfaces_1.UserActivityState.Active && state !== Interfaces_1.UserActivityState.Inactive) {
            throw new Error("setUserActivityState called with unsupported value " + state);
        }
        this.logger.info("setUserActivityState called with value " + Interfaces_1.UserActivityState[state]);
        if (this.trouterServer && this.state() !== Interfaces_1.TrouterState.Unknown) {
            this.trouterServer.setUserActivityState(state, correlationVector);
        }
        else {
            throw new Error('setUserActivityState called too early');
        }
    };
    // Legacy API
    TrouterService.prototype.state = function () {
        if (this.trouterServer !== undefined) {
            return this.trouterServer.getState();
        }
        return Interfaces_1.TrouterState.Unknown;
    };
    TrouterService.prototype.getServerState = function () {
        if (this.trouterServer !== undefined) {
            return this.trouterServer.getServerState();
        }
        return undefined;
    };
    // tslint:disable-next-line:promise-function-async
    TrouterService.prototype.getTrouterUrlAsync = function () {
        if (this.trouterServer !== undefined) {
            return this.trouterUrlPromise.getPromise();
        }
        else {
            return Promise.reject(new Error('TrouterService has not been started'));
        }
    };
    TrouterService.prototype.onStateChanged = function (callback) {
        this.logger.info('onStateChanged called');
        if (callback === undefined) {
            this.stateChangedListeners = this.stateChangedListeners.filter(function (listener) { return (listener.wrappedCallback === undefined); });
        }
        else {
            this.offStateChanged(callback);
            var wrapper = function (state, info) {
                callback(state, info ? info.url : '');
            };
            wrapper.wrappedCallback = callback;
            this.stateChangedListeners.push(wrapper);
        }
    };
    TrouterService.prototype.offStateChanged = function (callback) {
        this.logger.info('offStateChanged called');
        var sizeBeforeRemoval = this.stateChangedListeners.length;
        this.stateChangedListeners = this.stateChangedListeners.filter(function (listener) { return (listener.wrappedCallback !== callback); });
        return (sizeBeforeRemoval > this.stateChangedListeners.length);
    };
    TrouterService.prototype.addCallback = function (callback) {
        this.logger.info('addListener called');
        var index = this.stateChangedListeners.indexOf(callback, 0);
        if (index === -1 && callback !== undefined) {
            this.stateChangedListeners.push(callback);
        }
    };
    TrouterService.prototype.removeCallback = function (callback) {
        this.logger.info('removeListener called');
        var index = this.stateChangedListeners.indexOf(callback, 0);
        if (index > -1) {
            this.stateChangedListeners.splice(index, 1);
            return true;
        }
        return false;
    };
    TrouterService.prototype.registerMessageHandler = function (handler) {
        this.logger.info('registerMessageHandler is called');
        this.messageHandlers.register(handler);
    };
    TrouterService.prototype.clearMessageHandlers = function () {
        this.logger.info('clearMessageHandlers is called');
        this.messageHandlers.clear();
    };
    TrouterService.prototype.notifyStateChanged = function (state, info) {
        var _this = this;
        this.logger.info("notifyStateChanged called, will forward to " + this.stateChangedListeners.length + " listeners");
        this.stateChangedListeners.forEach(function (callback) {
            try {
                callback(state, info);
            }
            catch (error) {
                _this.logger.error("Error in callback " + error);
            }
        });
    };
    TrouterService.prototype.tryMessageHandlers = function (request, response) {
        if (!this.messageHandlers.active()) {
            return false;
        }
        var body;
        var eventId = null;
        try {
            body = JSON.parse(request.body);
            eventId = (body && (body.evt || body.eventId)) || null;
        }
        catch (e) { }
        var message = {
            eventId: eventId,
            url: (this.connectionInfo ? this.connectionInfo.baseEndpointUrl : '') + request.path,
            body: body,
            rawBody: request.body,
            headers: request.headers
        };
        var result = this.messageHandlers.handleMessage(message);
        if (!result.isHandled) {
            return false;
        }
        response.status = result.resultCode;
        if (result.responseHeaders) {
            response.headers = result.responseHeaders;
        }
        if (result.responseBody) {
            response.body = result.responseBody;
        }
        response.send();
        return true;
    };
    return TrouterService;
}());
exports.TrouterService = TrouterService;
function createTrouterService(logger) {
    return new TrouterService(logger);
}
exports.createTrouterService = createTrouterService;
function getTrouterServiceVersion() {
    return Constants_1.CLIENT_VERSION;
}
exports.getTrouterServiceVersion = getTrouterServiceVersion;
function replaceTrouterUrlBase(existingUrl, newBase) {
    var schemaSepPos = existingUrl.indexOf('://');
    if (schemaSepPos >= 0) {
        var pathSepPos = existingUrl.indexOf('/', schemaSepPos + 3);
        if (pathSepPos >= 0) {
            return newBase + existingUrl.substr(pathSepPos);
        }
    }
    return '';
}
exports.replaceTrouterUrlBase = replaceTrouterUrlBase;


/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_20__;

/***/ }),
/* 21 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// tstrouter.js